export const personInOffice = [
  {
      "COURT": "F1",
      "ID": "10351",
      "OFFICE": "Fs",
      "START": "",
      "END": ""
  },
  {
      "COURT": "F1",
      "ID": "10874",
      "OFFICE": "OK",
      "START": "",
      "END": ""
  },
  {
      "COURT": "F1",
      "ID": "11351",
      "OFFICE": "H3",
      "START": "",
      "END": ""
  },
  {
      "COURT": "F1",
      "ID": "11521",
      "OFFICE": "H3",
      "START": "",
      "END": ""
  },
  {
      "COURT": "F1",
      "ID": "12231",
      "OFFICE": "HCSek",
      "START": "",
      "END": ""
  },
  {
      "COURT": "F1",
      "ID": "13019",
      "OFFICE": "HR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "F1",
      "ID": "13019",
      "OFFICE": "OTs",
      "START": "",
      "END": ""
  },
  {
      "COURT": "F1",
      "ID": "13151",
      "OFFICE": "OHM",
      "START": "",
      "END": ""
  },
  {
      "COURT": "F1",
      "ID": "13152",
      "OFFICE": "HR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "F1",
      "ID": "13308",
      "OFFICE": "HR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "F1",
      "ID": "13308",
      "OFFICE": "Ms",
      "START": "",
      "END": ""
  },
  {
      "COURT": "F1",
      "ID": "13446",
      "OFFICE": "HR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "F1",
      "ID": "13785",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "F1",
      "ID": "14063",
      "OFFICE": "Fs",
      "START": "",
      "END": ""
  },
  {
      "COURT": "F1",
      "ID": "16127",
      "OFFICE": "Ms",
      "START": "",
      "END": ""
  },
  {
      "COURT": "F1",
      "ID": "17050",
      "OFFICE": "H1",
      "START": "",
      "END": ""
  },
  {
      "COURT": "F1",
      "ID": "17050",
      "OFFICE": "HPfenM",
      "START": "",
      "END": ""
  },
  {
      "COURT": "F1",
      "ID": "17112",
      "OFFICE": "Ts",
      "START": "",
      "END": ""
  },
  {
      "COURT": "F1",
      "ID": "17785",
      "OFFICE": "OHMar",
      "START": "",
      "END": ""
  },
  {
      "COURT": "F1",
      "ID": "18787",
      "OFFICE": "Ms",
      "START": "",
      "END": ""
  },
  {
      "COURT": "F1",
      "ID": "18791",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "F1",
      "ID": "19101",
      "OFFICE": "Ms",
      "START": "",
      "END": ""
  },
  {
      "COURT": "F1",
      "ID": "31693",
      "OFFICE": "H1",
      "START": "",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10002",
      "OFFICE": "K",
      "START": "1617",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10003",
      "OFFICE": "K",
      "START": "1619",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10005",
      "OFFICE": "K",
      "START": "1627",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10008",
      "OFFICE": "K",
      "START": "1617",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10009",
      "OFFICE": "K",
      "START": "1618",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10010",
      "OFFICE": "K",
      "START": "1623",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10015",
      "OFFICE": "K",
      "START": "1607",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10016",
      "OFFICE": "K",
      "START": "1606",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10017",
      "OFFICE": "K",
      "START": "1619",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10019",
      "OFFICE": "K",
      "START": "1630",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10021",
      "OFFICE": "K",
      "START": "1614",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10023",
      "OFFICE": "K",
      "START": "1621",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10024",
      "OFFICE": "K",
      "START": "1619",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10026",
      "OFFICE": "K",
      "START": "1627",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10027",
      "OFFICE": "K",
      "START": "1633",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10029",
      "OFFICE": "K",
      "START": "1618",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10030",
      "OFFICE": "K",
      "START": "1614",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10031",
      "OFFICE": "K",
      "START": "1617",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10032",
      "OFFICE": "K",
      "START": "1624",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10033",
      "OFFICE": "K",
      "START": "1618",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10034",
      "OFFICE": "K",
      "START": "1622",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10037",
      "OFFICE": "K",
      "START": "1627",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10039",
      "OFFICE": "K",
      "START": "1615",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10041",
      "OFFICE": "K",
      "START": "1618",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10042",
      "OFFICE": "K",
      "START": "1622",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10043",
      "OFFICE": "K",
      "START": "1631",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10044",
      "OFFICE": "K",
      "START": "1628",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10045",
      "OFFICE": "K",
      "START": "1635",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10046",
      "OFFICE": "K",
      "START": "1619",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10047",
      "OFFICE": "K",
      "START": "1614",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10048",
      "OFFICE": "K",
      "START": "1629",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10049",
      "OFFICE": "K",
      "START": "1629",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10052",
      "OFFICE": "K",
      "START": "1619",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10053",
      "OFFICE": "K",
      "START": "1613",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10058",
      "OFFICE": "K",
      "START": "1627",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10068",
      "OFFICE": "K",
      "START": "1623",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10072",
      "OFFICE": "K",
      "START": "1622",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10073",
      "OFFICE": "K",
      "START": "1622",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10077",
      "OFFICE": "K",
      "START": "1632",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10078",
      "OFFICE": "K",
      "START": "1631",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10081",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10082",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10083",
      "OFFICE": "K",
      "START": "1633",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10084",
      "OFFICE": "K",
      "START": "1631",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10089",
      "OFFICE": "K",
      "START": "1611",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10091",
      "OFFICE": "K",
      "START": "1625",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10093",
      "OFFICE": "K",
      "START": "1624",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10094",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10097",
      "OFFICE": "K",
      "START": "1629",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10102",
      "OFFICE": "K",
      "START": "1627",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10104",
      "OFFICE": "K",
      "START": "1619",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10105",
      "OFFICE": "K",
      "START": "1618",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10106",
      "OFFICE": "K",
      "START": "1614",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10113",
      "OFFICE": "K",
      "START": "1619",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10114",
      "OFFICE": "K",
      "START": "1619",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10115",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10117",
      "OFFICE": "K",
      "START": "1619",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10119",
      "OFFICE": "K",
      "START": "1619",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10124",
      "OFFICE": "K",
      "START": "1635",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10127",
      "OFFICE": "K",
      "START": "1619",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10128",
      "OFFICE": "K",
      "START": "1617",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10130",
      "OFFICE": "K",
      "START": "1606",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10132",
      "OFFICE": "K",
      "START": "1619",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10135",
      "OFFICE": "K",
      "START": "1620",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10136",
      "OFFICE": "K",
      "START": "1624",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10137",
      "OFFICE": "K",
      "START": "1619",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10141",
      "OFFICE": "K",
      "START": "1629",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10143",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10146",
      "OFFICE": "K",
      "START": "1631",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10150",
      "OFFICE": "K",
      "START": "1619",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10154",
      "OFFICE": "K",
      "START": "1629",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10157",
      "OFFICE": "K",
      "START": "1635",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10163",
      "OFFICE": "K",
      "START": "1622",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10165",
      "OFFICE": "K",
      "START": "1633",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10169",
      "OFFICE": "K",
      "START": "1619",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10177",
      "OFFICE": "K",
      "START": "1630",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10194",
      "OFFICE": "K",
      "START": "1627",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10196",
      "OFFICE": "K",
      "START": "1622",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10197",
      "OFFICE": "K",
      "START": "1635",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10198",
      "OFFICE": "K",
      "START": "1631",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10213",
      "OFFICE": "K",
      "START": "1632",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10215",
      "OFFICE": "K",
      "START": "1622",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10220",
      "OFFICE": "K",
      "START": "1618",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10221",
      "OFFICE": "K",
      "START": "1618",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10229",
      "OFFICE": "K",
      "START": "1619",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10246",
      "OFFICE": "K",
      "START": "1625",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10255",
      "OFFICE": "K",
      "START": "1629",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10268",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10295",
      "OFFICE": "K",
      "START": "1618",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10301",
      "OFFICE": "K",
      "START": "1620",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10322",
      "OFFICE": "K",
      "START": "1625",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10323",
      "OFFICE": "K",
      "START": "1619",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10355",
      "OFFICE": "K",
      "START": "1619",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10358",
      "OFFICE": "K",
      "START": "1628",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10362",
      "OFFICE": "K",
      "START": "1625",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10369",
      "OFFICE": "K",
      "START": "1627",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10370",
      "OFFICE": "K",
      "START": "1617",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10380",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10389",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10397",
      "OFFICE": "K",
      "START": "1635",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10410",
      "OFFICE": "K",
      "START": "1619",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10411",
      "OFFICE": "K",
      "START": "1623",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10416",
      "OFFICE": "K",
      "START": "1622",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10424",
      "OFFICE": "K",
      "START": "1619",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10429",
      "OFFICE": "K",
      "START": "1618",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10448",
      "OFFICE": "K",
      "START": "1619",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10475",
      "OFFICE": "K",
      "START": "1632",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10477",
      "OFFICE": "K",
      "START": "1630",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10492",
      "OFFICE": "K",
      "START": "1623",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10498",
      "OFFICE": "K",
      "START": "1619",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10499",
      "OFFICE": "K",
      "START": "1622",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10504",
      "OFFICE": "K",
      "START": "1620",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10518",
      "OFFICE": "K",
      "START": "1628",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10530",
      "OFFICE": "K",
      "START": "1620",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10542",
      "OFFICE": "K",
      "START": "1617",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10551",
      "OFFICE": "K",
      "START": "1626",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10568",
      "OFFICE": "K",
      "START": "1621",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10578",
      "OFFICE": "K",
      "START": "1632",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10580",
      "OFFICE": "K",
      "START": "1633",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10582",
      "OFFICE": "K",
      "START": "1633",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10603",
      "OFFICE": "K",
      "START": "1619",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10618",
      "OFFICE": "K",
      "START": "1622",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10627",
      "OFFICE": "K",
      "START": "1627",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10631",
      "OFFICE": "K",
      "START": "1628",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10636",
      "OFFICE": "K",
      "START": "1624",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10637",
      "OFFICE": "K",
      "START": "1614",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10640",
      "OFFICE": "K",
      "START": "1620",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10644",
      "OFFICE": "K",
      "START": "1619",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10663",
      "OFFICE": "K",
      "START": "1630",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10672",
      "OFFICE": "K",
      "START": "1621",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10673",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10675",
      "OFFICE": "K",
      "START": "1628",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10682",
      "OFFICE": "K",
      "START": "1618",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10687",
      "OFFICE": "K",
      "START": "1635",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10692",
      "OFFICE": "K",
      "START": "1635",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10707",
      "OFFICE": "K",
      "START": "1623",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10719",
      "OFFICE": "K",
      "START": "1626",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10728",
      "OFFICE": "K",
      "START": "1619",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10749",
      "OFFICE": "K",
      "START": "1617",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10762",
      "OFFICE": "K",
      "START": "1618",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10767",
      "OFFICE": "K",
      "START": "1617",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10768",
      "OFFICE": "K",
      "START": "1628",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10777",
      "OFFICE": "K",
      "START": "1619",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10778",
      "OFFICE": "K",
      "START": "1623",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10787",
      "OFFICE": "K",
      "START": "1627",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10808",
      "OFFICE": "K",
      "START": "1631",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10817",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10820",
      "OFFICE": "K",
      "START": "1630",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10825",
      "OFFICE": "K",
      "START": "1623",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10831",
      "OFFICE": "K",
      "START": "1634",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10836",
      "OFFICE": "K",
      "START": "1622",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10839",
      "OFFICE": "K",
      "START": "1635",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10851",
      "OFFICE": "K",
      "START": "1620",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10853",
      "OFFICE": "K",
      "START": "1633",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10870",
      "OFFICE": "K",
      "START": "1623",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10879",
      "OFFICE": "K",
      "START": "1621",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10893",
      "OFFICE": "K",
      "START": "1619",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10894",
      "OFFICE": "K",
      "START": "1624",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10903",
      "OFFICE": "K",
      "START": "1621",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10915",
      "OFFICE": "K",
      "START": "1619",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10967",
      "OFFICE": "K",
      "START": "1617",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10972",
      "OFFICE": "K",
      "START": "1617",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10986",
      "OFFICE": "K",
      "START": "1619",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10989",
      "OFFICE": "K",
      "START": "1629",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "10996",
      "OFFICE": "K",
      "START": "1627",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11007",
      "OFFICE": "K",
      "START": "1618",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11012",
      "OFFICE": "K",
      "START": "1622",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11043",
      "OFFICE": "K",
      "START": "1627",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11050",
      "OFFICE": "K",
      "START": "1620",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11062",
      "OFFICE": "K",
      "START": "1621",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11063",
      "OFFICE": "K",
      "START": "1621",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11078",
      "OFFICE": "K",
      "START": "1627",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11081",
      "OFFICE": "K",
      "START": "1619",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11082",
      "OFFICE": "K",
      "START": "1624",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11098",
      "OFFICE": "K",
      "START": "1620",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11099",
      "OFFICE": "K",
      "START": "1633",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11105",
      "OFFICE": "K",
      "START": "1634",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11122",
      "OFFICE": "K",
      "START": "1634",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11123",
      "OFFICE": "K",
      "START": "1631",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11131",
      "OFFICE": "K",
      "START": "1633",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11142",
      "OFFICE": "K",
      "START": "1628",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11146",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11148",
      "OFFICE": "K",
      "START": "1617",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11154",
      "OFFICE": "K",
      "START": "1623",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11156",
      "OFFICE": "K",
      "START": "1623",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11168",
      "OFFICE": "K",
      "START": "1635",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11176",
      "OFFICE": "K",
      "START": "1635",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11184",
      "OFFICE": "K",
      "START": "1635",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11204",
      "OFFICE": "K",
      "START": "1629",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11205",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11208",
      "OFFICE": "K",
      "START": "1606",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11209",
      "OFFICE": "K",
      "START": "1629",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11219",
      "OFFICE": "K",
      "START": "1635",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11220",
      "OFFICE": "K",
      "START": "1635",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11221",
      "OFFICE": "K",
      "START": "1634",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11222",
      "OFFICE": "K",
      "START": "1621",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11223",
      "OFFICE": "K",
      "START": "1628",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11225",
      "OFFICE": "K",
      "START": "1632",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11228",
      "OFFICE": "K",
      "START": "1627",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11231",
      "OFFICE": "K",
      "START": "1619",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11236",
      "OFFICE": "K",
      "START": "1625",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11238",
      "OFFICE": "K",
      "START": "1617",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11242",
      "OFFICE": "K",
      "START": "1631",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11244",
      "OFFICE": "K",
      "START": "1619",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11245",
      "OFFICE": "K",
      "START": "1619",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11250",
      "OFFICE": "K",
      "START": "1619",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11255",
      "OFFICE": "K",
      "START": "1625",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11261",
      "OFFICE": "K",
      "START": "1628",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11270",
      "OFFICE": "K",
      "START": "1628",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11275",
      "OFFICE": "K",
      "START": "1618",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11290",
      "OFFICE": "K",
      "START": "1619",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11299",
      "OFFICE": "K",
      "START": "1624",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11310",
      "OFFICE": "K",
      "START": "1619",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11336",
      "OFFICE": "K",
      "START": "1627",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11337",
      "OFFICE": "K",
      "START": "1629",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11338",
      "OFFICE": "K",
      "START": "1635",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11339",
      "OFFICE": "K",
      "START": "1612",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11357",
      "OFFICE": "K",
      "START": "1634",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11358",
      "OFFICE": "K",
      "START": "1634",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11362",
      "OFFICE": "K",
      "START": "1628",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11363",
      "OFFICE": "K",
      "START": "1618",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11367",
      "OFFICE": "K",
      "START": "1617",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11386",
      "OFFICE": "K",
      "START": "1628",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11391",
      "OFFICE": "K",
      "START": "1619",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11399",
      "OFFICE": "K",
      "START": "1630",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11410",
      "OFFICE": "K",
      "START": "1618",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11481",
      "OFFICE": "K",
      "START": "1634",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11501",
      "OFFICE": "K",
      "START": "1616",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11504",
      "OFFICE": "K",
      "START": "1620",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11520",
      "OFFICE": "K",
      "START": "1618",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11523",
      "OFFICE": "K",
      "START": "1626",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11527",
      "OFFICE": "K",
      "START": "1618",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11532",
      "OFFICE": "K",
      "START": "1620",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11539",
      "OFFICE": "K",
      "START": "1634",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11545",
      "OFFICE": "K",
      "START": "1617",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11565",
      "OFFICE": "K",
      "START": "1635",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11603",
      "OFFICE": "K",
      "START": "1620",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11608",
      "OFFICE": "K",
      "START": "1620",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11609",
      "OFFICE": "K",
      "START": "1633",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11613",
      "OFFICE": "K",
      "START": "1635",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11616",
      "OFFICE": "K",
      "START": "1634",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11617",
      "OFFICE": "K",
      "START": "1635",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11619",
      "OFFICE": "K",
      "START": "1634",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11620",
      "OFFICE": "K",
      "START": "1621",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11622",
      "OFFICE": "K",
      "START": "1624",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11625",
      "OFFICE": "K",
      "START": "1630",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11626",
      "OFFICE": "K",
      "START": "1634",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11627",
      "OFFICE": "K",
      "START": "1627",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11629",
      "OFFICE": "K",
      "START": "1618",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11630",
      "OFFICE": "K",
      "START": "1618",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11657",
      "OFFICE": "K",
      "START": "1619",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11659",
      "OFFICE": "K",
      "START": "1623",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11662",
      "OFFICE": "K",
      "START": "1629",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11663",
      "OFFICE": "K",
      "START": "1630",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11693",
      "OFFICE": "K",
      "START": "1627",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11702",
      "OFFICE": "K",
      "START": "1628",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11708",
      "OFFICE": "K",
      "START": "1626",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11721",
      "OFFICE": "K",
      "START": "1627",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11722",
      "OFFICE": "K",
      "START": "1623",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11728",
      "OFFICE": "K",
      "START": "1618",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11729",
      "OFFICE": "K",
      "START": "1632",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11731",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11732",
      "OFFICE": "K",
      "START": "1619",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11737",
      "OFFICE": "K",
      "START": "1628",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11758",
      "OFFICE": "K",
      "START": "1619",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11779",
      "OFFICE": "K",
      "START": "1624",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11780",
      "OFFICE": "K",
      "START": "1624",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11796",
      "OFFICE": "K",
      "START": "1619",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11826",
      "OFFICE": "K",
      "START": "1633",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11828",
      "OFFICE": "K",
      "START": "1635",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11840",
      "OFFICE": "K",
      "START": "1623",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11845",
      "OFFICE": "K",
      "START": "1628",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11846",
      "OFFICE": "K",
      "START": "1628",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11853",
      "OFFICE": "K",
      "START": "1635",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11898",
      "OFFICE": "K",
      "START": "1620",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11899",
      "OFFICE": "K",
      "START": "1635",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "11978",
      "OFFICE": "K",
      "START": "1622",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12013",
      "OFFICE": "K",
      "START": "1618",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12031",
      "OFFICE": "K",
      "START": "1624",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12048",
      "OFFICE": "K",
      "START": "1625",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12053",
      "OFFICE": "K",
      "START": "1635",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12057",
      "OFFICE": "K",
      "START": "1627",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12074",
      "OFFICE": "K",
      "START": "1630",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12101",
      "OFFICE": "K",
      "START": "1627",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12109",
      "OFFICE": "K",
      "START": "1621",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12125",
      "OFFICE": "K",
      "START": "1634",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12135",
      "OFFICE": "K",
      "START": "1629",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12190",
      "OFFICE": "K",
      "START": "1622",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12191",
      "OFFICE": "K",
      "START": "1630",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12202",
      "OFFICE": "K",
      "START": "1619",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12211",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12214",
      "OFFICE": "K",
      "START": "1629",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12219",
      "OFFICE": "K",
      "START": "1630",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12223",
      "OFFICE": "K",
      "START": "1613",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12228",
      "OFFICE": "K",
      "START": "1629",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12248",
      "OFFICE": "K",
      "START": "1618",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12254",
      "OFFICE": "K",
      "START": "1635",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12261",
      "OFFICE": "K",
      "START": "1613",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12266",
      "OFFICE": "K",
      "START": "1624",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12278",
      "OFFICE": "K",
      "START": "1622",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12280",
      "OFFICE": "K",
      "START": "1625",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12289",
      "OFFICE": "K",
      "START": "1614",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12295",
      "OFFICE": "K",
      "START": "1625",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12296",
      "OFFICE": "K",
      "START": "1615",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12315",
      "OFFICE": "K",
      "START": "1619",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12329",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12334",
      "OFFICE": "K",
      "START": "1635",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12356",
      "OFFICE": "K",
      "START": "1622",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12361",
      "OFFICE": "K",
      "START": "1622",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12399",
      "OFFICE": "K",
      "START": "1635",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12417",
      "OFFICE": "K",
      "START": "1615",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12427",
      "OFFICE": "K",
      "START": "1621",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12453",
      "OFFICE": "K",
      "START": "1608",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12460",
      "OFFICE": "K",
      "START": "1617",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12503",
      "OFFICE": "K",
      "START": "1632",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12505",
      "OFFICE": "K",
      "START": "1621",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12507",
      "OFFICE": "K",
      "START": "1623",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12509",
      "OFFICE": "K",
      "START": "1618",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12514",
      "OFFICE": "K",
      "START": "1623",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12521",
      "OFFICE": "K",
      "START": "1629",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12534",
      "OFFICE": "K",
      "START": "1622",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12545",
      "OFFICE": "K",
      "START": "1606",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12562",
      "OFFICE": "K",
      "START": "1619",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12572",
      "OFFICE": "K",
      "START": "1632",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12573",
      "OFFICE": "K",
      "START": "1623",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12576",
      "OFFICE": "K",
      "START": "1625",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12582",
      "OFFICE": "K",
      "START": "1623",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12583",
      "OFFICE": "K",
      "START": "1620",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12585",
      "OFFICE": "K",
      "START": "1624",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12602",
      "OFFICE": "K",
      "START": "1635",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12607",
      "OFFICE": "K",
      "START": "1622",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12652",
      "OFFICE": "K",
      "START": "1627",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12655",
      "OFFICE": "K",
      "START": "1619",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12671",
      "OFFICE": "K",
      "START": "1618",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12674",
      "OFFICE": "K",
      "START": "1629",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12677",
      "OFFICE": "K",
      "START": "1628",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12680",
      "OFFICE": "K",
      "START": "1625",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12683",
      "OFFICE": "K",
      "START": "1635",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12689",
      "OFFICE": "K",
      "START": "1618",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12696",
      "OFFICE": "K",
      "START": "1618",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12710",
      "OFFICE": "K",
      "START": "1635",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12714",
      "OFFICE": "K",
      "START": "1635",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12716",
      "OFFICE": "K",
      "START": "1631",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12725",
      "OFFICE": "K",
      "START": "1623",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12727",
      "OFFICE": "K",
      "START": "1614",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12731",
      "OFFICE": "K",
      "START": "1618",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12734",
      "OFFICE": "K",
      "START": "1630",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12765",
      "OFFICE": "K",
      "START": "1622",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12789",
      "OFFICE": "K",
      "START": "1625",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12790",
      "OFFICE": "K",
      "START": "1627",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12792",
      "OFFICE": "K",
      "START": "1619",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12798",
      "OFFICE": "K",
      "START": "1635",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12801",
      "OFFICE": "K",
      "START": "1625",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12818",
      "OFFICE": "K",
      "START": "1630",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12821",
      "OFFICE": "K",
      "START": "1621",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12828",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12830",
      "OFFICE": "K",
      "START": "1623",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12831",
      "OFFICE": "K",
      "START": "1611",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12834",
      "OFFICE": "K",
      "START": "1628",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12835",
      "OFFICE": "K",
      "START": "1612",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12855",
      "OFFICE": "K",
      "START": "1619",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12870",
      "OFFICE": "K",
      "START": "1623",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12880",
      "OFFICE": "K",
      "START": "1622",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12888",
      "OFFICE": "K",
      "START": "1627",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12893",
      "OFFICE": "K",
      "START": "1633",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12896",
      "OFFICE": "K",
      "START": "1614",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12898",
      "OFFICE": "K",
      "START": "1610",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12899",
      "OFFICE": "K",
      "START": "1635",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12905",
      "OFFICE": "K",
      "START": "1635",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12920",
      "OFFICE": "K",
      "START": "1618",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12932",
      "OFFICE": "K",
      "START": "1631",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12940",
      "OFFICE": "K",
      "START": "1621",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12952",
      "OFFICE": "K",
      "START": "1625",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12953",
      "OFFICE": "K",
      "START": "1631",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12958",
      "OFFICE": "K",
      "START": "1618",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12969",
      "OFFICE": "K",
      "START": "1623",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12972",
      "OFFICE": "K",
      "START": "1619",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12974",
      "OFFICE": "K",
      "START": "1618",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "12975",
      "OFFICE": "K",
      "START": "1621",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13004",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13005",
      "OFFICE": "K",
      "START": "1616",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13016",
      "OFFICE": "K",
      "START": "1621",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13017",
      "OFFICE": "K",
      "START": "1634",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13029",
      "OFFICE": "K",
      "START": "1627",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13032",
      "OFFICE": "K",
      "START": "1617",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13037",
      "OFFICE": "K",
      "START": "1629",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13040",
      "OFFICE": "K",
      "START": "1631",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13059",
      "OFFICE": "K",
      "START": "1634",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13067",
      "OFFICE": "K",
      "START": "1628",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13069",
      "OFFICE": "K",
      "START": "1622",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13079",
      "OFFICE": "K",
      "START": "1621",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13081",
      "OFFICE": "K",
      "START": "1622",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13089",
      "OFFICE": "K",
      "START": "1623",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13090",
      "OFFICE": "K",
      "START": "1619",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13109",
      "OFFICE": "K",
      "START": "1612",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13110",
      "OFFICE": "K",
      "START": "1624",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13121",
      "OFFICE": "K",
      "START": "1617",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13122",
      "OFFICE": "K",
      "START": "1619",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13126",
      "OFFICE": "K",
      "START": "1625",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13132",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13133",
      "OFFICE": "K",
      "START": "1631",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13134",
      "OFFICE": "K",
      "START": "1631",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13137",
      "OFFICE": "K",
      "START": "1623",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13146",
      "OFFICE": "K",
      "START": "1619",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13147",
      "OFFICE": "K",
      "START": "1628",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13148",
      "OFFICE": "K",
      "START": "1620",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13149",
      "OFFICE": "K",
      "START": "1620",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13168",
      "OFFICE": "K",
      "START": "1618",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13174",
      "OFFICE": "K",
      "START": "1619",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13194",
      "OFFICE": "K",
      "START": "1606",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13195",
      "OFFICE": "K",
      "START": "1606",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13196",
      "OFFICE": "K",
      "START": "1607",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13197",
      "OFFICE": "K",
      "START": "1611",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13198",
      "OFFICE": "K",
      "START": "1635",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13209",
      "OFFICE": "K",
      "START": "1632",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13215",
      "OFFICE": "K",
      "START": "1630",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13230",
      "OFFICE": "K",
      "START": "1622",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13247",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13249",
      "OFFICE": "K",
      "START": "1634",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13254",
      "OFFICE": "K",
      "START": "1622",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13266",
      "OFFICE": "K",
      "START": "1619",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13267",
      "OFFICE": "K",
      "START": "1628",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13297",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13298",
      "OFFICE": "K",
      "START": "1632",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13302",
      "OFFICE": "K",
      "START": "1621",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13311",
      "OFFICE": "K",
      "START": "1614",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13315",
      "OFFICE": "K",
      "START": "1622",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13318",
      "OFFICE": "K",
      "START": "1628",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13319",
      "OFFICE": "K",
      "START": "1621",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13322",
      "OFFICE": "K",
      "START": "1626",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13323",
      "OFFICE": "K",
      "START": "1632",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13324",
      "OFFICE": "K",
      "START": "1628",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13327",
      "OFFICE": "K",
      "START": "1622",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13329",
      "OFFICE": "K",
      "START": "1621",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13332",
      "OFFICE": "K",
      "START": "1614",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13334",
      "OFFICE": "K",
      "START": "1623",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13348",
      "OFFICE": "K",
      "START": "1615",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13359",
      "OFFICE": "K",
      "START": "1622",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13360",
      "OFFICE": "K",
      "START": "1635",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13365",
      "OFFICE": "K",
      "START": "1619",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13367",
      "OFFICE": "K",
      "START": "1611",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13368",
      "OFFICE": "K",
      "START": "1634",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13369",
      "OFFICE": "K",
      "START": "1624",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13378",
      "OFFICE": "K",
      "START": "1613",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13379",
      "OFFICE": "K",
      "START": "1612",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13383",
      "OFFICE": "K",
      "START": "1619",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13386",
      "OFFICE": "K",
      "START": "1628",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13388",
      "OFFICE": "K",
      "START": "1620",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13389",
      "OFFICE": "K",
      "START": "1628",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13391",
      "OFFICE": "K",
      "START": "1617",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13392",
      "OFFICE": "K",
      "START": "1622",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13396",
      "OFFICE": "K",
      "START": "1615",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13397",
      "OFFICE": "K",
      "START": "1630",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13401",
      "OFFICE": "K",
      "START": "1619",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13423",
      "OFFICE": "K",
      "START": "1623",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13426",
      "OFFICE": "K",
      "START": "1630",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13430",
      "OFFICE": "K",
      "START": "1622",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13440",
      "OFFICE": "K",
      "START": "1619",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13445",
      "OFFICE": "K",
      "START": "1625",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13458",
      "OFFICE": "K",
      "START": "1630",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13478",
      "OFFICE": "K",
      "START": "1634",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13487",
      "OFFICE": "K",
      "START": "1624",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13489",
      "OFFICE": "K",
      "START": "1623",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13501",
      "OFFICE": "K",
      "START": "1613",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13502",
      "OFFICE": "K",
      "START": "1617",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13503",
      "OFFICE": "K",
      "START": "1625",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13504",
      "OFFICE": "K",
      "START": "1628",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13506",
      "OFFICE": "K",
      "START": "1631",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13514",
      "OFFICE": "K",
      "START": "1606",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13515",
      "OFFICE": "K",
      "START": "1612",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13540",
      "OFFICE": "K",
      "START": "1621",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13543",
      "OFFICE": "K",
      "START": "1630",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13544",
      "OFFICE": "K",
      "START": "1630",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13546",
      "OFFICE": "K",
      "START": "1631",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13548",
      "OFFICE": "K",
      "START": "1628",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13549",
      "OFFICE": "K",
      "START": "1629",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13555",
      "OFFICE": "K",
      "START": "1620",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13557",
      "OFFICE": "K",
      "START": "1619",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13560",
      "OFFICE": "K",
      "START": "1620",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13561",
      "OFFICE": "K",
      "START": "1622",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13562",
      "OFFICE": "K",
      "START": "1631",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13582",
      "OFFICE": "K",
      "START": "1632",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13586",
      "OFFICE": "K",
      "START": "1622",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13587",
      "OFFICE": "K",
      "START": "1622",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13589",
      "OFFICE": "K",
      "START": "1620",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13590",
      "OFFICE": "K",
      "START": "1624",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13591",
      "OFFICE": "K",
      "START": "1623",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13598",
      "OFFICE": "K",
      "START": "1634",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13604",
      "OFFICE": "K",
      "START": "1613",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13641",
      "OFFICE": "K",
      "START": "1621",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13642",
      "OFFICE": "K",
      "START": "1612",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13643",
      "OFFICE": "K",
      "START": "1623",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13644",
      "OFFICE": "K",
      "START": "1624",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13655",
      "OFFICE": "K",
      "START": "1631",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13659",
      "OFFICE": "K",
      "START": "1634",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13661",
      "OFFICE": "K",
      "START": "1628",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13662",
      "OFFICE": "K",
      "START": "1635",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13666",
      "OFFICE": "K",
      "START": "1625",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13685",
      "OFFICE": "K",
      "START": "1631",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13709",
      "OFFICE": "K",
      "START": "1617",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13710",
      "OFFICE": "K",
      "START": "1627",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13728",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13729",
      "OFFICE": "K",
      "START": "1606",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13730",
      "OFFICE": "K",
      "START": "1620",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13732",
      "OFFICE": "K",
      "START": "1635",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13733",
      "OFFICE": "K",
      "START": "1635",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13740",
      "OFFICE": "K",
      "START": "1625",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13751",
      "OFFICE": "K",
      "START": "1631",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13752",
      "OFFICE": "K",
      "START": "1620",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13753",
      "OFFICE": "K",
      "START": "1618",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13754",
      "OFFICE": "K",
      "START": "1631",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13755",
      "OFFICE": "K",
      "START": "1613",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13756",
      "OFFICE": "K",
      "START": "1633",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13762",
      "OFFICE": "K",
      "START": "1621",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13777",
      "OFFICE": "K",
      "START": "1633",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13781",
      "OFFICE": "K",
      "START": "1631",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13782",
      "OFFICE": "K",
      "START": "1632",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13783",
      "OFFICE": "K",
      "START": "1625",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13804",
      "OFFICE": "K",
      "START": "1631",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13810",
      "OFFICE": "K",
      "START": "1627",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13818",
      "OFFICE": "K",
      "START": "1623",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13885",
      "OFFICE": "K",
      "START": "1630",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13886",
      "OFFICE": "K",
      "START": "1622",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13889",
      "OFFICE": "K",
      "START": "1634",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13891",
      "OFFICE": "K",
      "START": "1619",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13895",
      "OFFICE": "K",
      "START": "1609",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13898",
      "OFFICE": "K",
      "START": "1632",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13899",
      "OFFICE": "K",
      "START": "1633",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13909",
      "OFFICE": "K",
      "START": "1623",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "13999",
      "OFFICE": "K",
      "START": "1635",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14004",
      "OFFICE": "K",
      "START": "1631",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14029",
      "OFFICE": "K",
      "START": "1624",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14033",
      "OFFICE": "K",
      "START": "1623",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14077",
      "OFFICE": "K",
      "START": "1606",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14088",
      "OFFICE": "K",
      "START": "1611",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14091",
      "OFFICE": "K",
      "START": "1628",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14093",
      "OFFICE": "K",
      "START": "1606",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14105",
      "OFFICE": "K",
      "START": "1627",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14106",
      "OFFICE": "K",
      "START": "1635",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14123",
      "OFFICE": "K",
      "START": "1635",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14124",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14125",
      "OFFICE": "K",
      "START": "1620",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14126",
      "OFFICE": "K",
      "START": "1634",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14146",
      "OFFICE": "K",
      "START": "1622",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14153",
      "OFFICE": "K",
      "START": "1628",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14158",
      "OFFICE": "K",
      "START": "1617",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14170",
      "OFFICE": "K",
      "START": "1627",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14173",
      "OFFICE": "K",
      "START": "1619",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14174",
      "OFFICE": "K",
      "START": "1616",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14176",
      "OFFICE": "K",
      "START": "1627",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14177",
      "OFFICE": "K",
      "START": "1635",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14180",
      "OFFICE": "K",
      "START": "1625",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14186",
      "OFFICE": "K",
      "START": "1619",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14188",
      "OFFICE": "K",
      "START": "1629",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14190",
      "OFFICE": "K",
      "START": "1623",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14191",
      "OFFICE": "K",
      "START": "1635",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14197",
      "OFFICE": "K",
      "START": "1627",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14199",
      "OFFICE": "K",
      "START": "1635",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14301",
      "OFFICE": "K",
      "START": "1633",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14306",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14307",
      "OFFICE": "K",
      "START": "1616",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14312",
      "OFFICE": "K",
      "START": "1616",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14317",
      "OFFICE": "K",
      "START": "1614",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14323",
      "OFFICE": "K",
      "START": "1635",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14343",
      "OFFICE": "K",
      "START": "1624",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14344",
      "OFFICE": "K",
      "START": "1627",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14345",
      "OFFICE": "K",
      "START": "1632",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14350",
      "OFFICE": "K",
      "START": "1635",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14353",
      "OFFICE": "K",
      "START": "1623",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14358",
      "OFFICE": "K",
      "START": "1635",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14359",
      "OFFICE": "K",
      "START": "1627",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14370",
      "OFFICE": "K",
      "START": "1627",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14378",
      "OFFICE": "K",
      "START": "1627",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14379",
      "OFFICE": "K",
      "START": "1622",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14380",
      "OFFICE": "K",
      "START": "1633",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14381",
      "OFFICE": "K",
      "START": "1624",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14391",
      "OFFICE": "K",
      "START": "1619",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14393",
      "OFFICE": "K",
      "START": "1631",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14397",
      "OFFICE": "K",
      "START": "1635",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14413",
      "OFFICE": "K",
      "START": "1614",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14416",
      "OFFICE": "K",
      "START": "1619",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14433",
      "OFFICE": "K",
      "START": "1627",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14435",
      "OFFICE": "K",
      "START": "1629",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14440",
      "OFFICE": "K",
      "START": "1634",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14446",
      "OFFICE": "K",
      "START": "1624",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14449",
      "OFFICE": "K",
      "START": "1625",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14452",
      "OFFICE": "K",
      "START": "1619",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14455",
      "OFFICE": "K",
      "START": "1621",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14456",
      "OFFICE": "K",
      "START": "1624",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14460",
      "OFFICE": "K",
      "START": "1619",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14477",
      "OFFICE": "K",
      "START": "1618",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14495",
      "OFFICE": "K",
      "START": "1635",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14502",
      "OFFICE": "K",
      "START": "1618",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14503",
      "OFFICE": "K",
      "START": "1619",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14506",
      "OFFICE": "K",
      "START": "1625",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14514",
      "OFFICE": "K",
      "START": "1617",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14516",
      "OFFICE": "K",
      "START": "1615",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14517",
      "OFFICE": "K",
      "START": "1625",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14518",
      "OFFICE": "K",
      "START": "1628",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14527",
      "OFFICE": "K",
      "START": "1629",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14546",
      "OFFICE": "K",
      "START": "1627",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14548",
      "OFFICE": "K",
      "START": "1632",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14560",
      "OFFICE": "K",
      "START": "1617",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14561",
      "OFFICE": "K",
      "START": "1620",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14568",
      "OFFICE": "K",
      "START": "1619",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14589",
      "OFFICE": "K",
      "START": "1613",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14592",
      "OFFICE": "K",
      "START": "1627",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14599",
      "OFFICE": "K",
      "START": "1632",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14602",
      "OFFICE": "K",
      "START": "1618",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14610",
      "OFFICE": "K",
      "START": "1618",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14611",
      "OFFICE": "K",
      "START": "1617",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14634",
      "OFFICE": "K",
      "START": "1628",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14635",
      "OFFICE": "K",
      "START": "1628",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14637",
      "OFFICE": "K",
      "START": "1623",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14649",
      "OFFICE": "K",
      "START": "1628",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14650",
      "OFFICE": "K",
      "START": "1630",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14651",
      "OFFICE": "K",
      "START": "1634",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14652",
      "OFFICE": "K",
      "START": "1632",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14656",
      "OFFICE": "K",
      "START": "1631",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14666",
      "OFFICE": "K",
      "START": "1633",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14696",
      "OFFICE": "K",
      "START": "1623",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14701",
      "OFFICE": "K",
      "START": "1619",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14709",
      "OFFICE": "K",
      "START": "1623",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14736",
      "OFFICE": "K",
      "START": "1635",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14743",
      "OFFICE": "K",
      "START": "1630",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14744",
      "OFFICE": "K",
      "START": "1613",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14749",
      "OFFICE": "K",
      "START": "1635",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14750",
      "OFFICE": "K",
      "START": "1613",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14751",
      "OFFICE": "K",
      "START": "1635",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14778",
      "OFFICE": "K",
      "START": "1625",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14784",
      "OFFICE": "K",
      "START": "1625",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14791",
      "OFFICE": "K",
      "START": "1633",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14793",
      "OFFICE": "K",
      "START": "1628",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14799",
      "OFFICE": "K",
      "START": "1632",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14821",
      "OFFICE": "K",
      "START": "1615",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14823",
      "OFFICE": "K",
      "START": "1613",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14824",
      "OFFICE": "K",
      "START": "1628",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14897",
      "OFFICE": "K",
      "START": "1628",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14898",
      "OFFICE": "K",
      "START": "1628",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14951",
      "OFFICE": "K",
      "START": "1631",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14952",
      "OFFICE": "K",
      "START": "1631",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14957",
      "OFFICE": "K",
      "START": "1635",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14959",
      "OFFICE": "K",
      "START": "1634",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "14972",
      "OFFICE": "K",
      "START": "1634",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "15317",
      "OFFICE": "K",
      "START": "1620",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "15741",
      "OFFICE": "K",
      "START": "1620",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "15769",
      "OFFICE": "K",
      "START": "1617",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "15820",
      "OFFICE": "K",
      "START": "1620",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "16045",
      "OFFICE": "K",
      "START": "1623",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "16397",
      "OFFICE": "K",
      "START": "1631",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "16941",
      "OFFICE": "K",
      "START": "1617",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "17165",
      "OFFICE": "K",
      "START": "1624",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "17185",
      "OFFICE": "K",
      "START": "1621",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "17222",
      "OFFICE": "K",
      "START": "1618",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "17317",
      "OFFICE": "K",
      "START": "1614",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "17478",
      "OFFICE": "K",
      "START": "1617",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "17678",
      "OFFICE": "K",
      "START": "1626",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "17889",
      "OFFICE": "K",
      "START": "1626",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "17925",
      "OFFICE": "K",
      "START": "1623",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "19031",
      "OFFICE": "K",
      "START": "1632",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "19344",
      "OFFICE": "K",
      "START": "1625",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "19425",
      "OFFICE": "K",
      "START": "1629",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "19572",
      "OFFICE": "K",
      "START": "1634",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "19631",
      "OFFICE": "K",
      "START": "1618",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "19646",
      "OFFICE": "K",
      "START": "1634",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "19866",
      "OFFICE": "K",
      "START": "1634",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "31317",
      "OFFICE": "K",
      "START": "1625",
      "END": ""
  },
  {
      "COURT": "F2",
      "ID": "31558",
      "OFFICE": "K",
      "START": "1635",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10002",
      "OFFICE": "GR",
      "START": "1628-01-01",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10002",
      "OFFICE": "OHM",
      "START": "1619",
      "END": "1635-03-27"
  },
  {
      "COURT": "F3",
      "ID": "10003",
      "OFFICE": "GR",
      "START": "1635-04-01",
      "END": "1650-06-07"
  },
  {
      "COURT": "F3",
      "ID": "10003",
      "OFFICE": "K0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10003",
      "OFFICE": "OHM",
      "START": "1635-04-01",
      "END": "1650-06-07"
  },
  {
      "COURT": "F3",
      "ID": "10004",
      "OFFICE": "GR",
      "START": "1646-06-21",
      "END": "1657-06-30"
  },
  {
      "COURT": "F3",
      "ID": "10004",
      "OFFICE": "OHM",
      "START": "1655-12-01",
      "END": "1657-06-30"
  },
  {
      "COURT": "F3",
      "ID": "10004",
      "OFFICE": "RHR",
      "START": "1640-01-15",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10005",
      "OFFICE": "GR",
      "START": "1637-04-30",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10007",
      "OFFICE": "K",
      "START": "1627",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10007",
      "OFFICE": "K0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10008",
      "OFFICE": "K",
      "START": "1637-04-11",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10009",
      "OFFICE": "GR",
      "START": "1637-03-24",
      "END": "1651-08-22"
  },
  {
      "COURT": "F3",
      "ID": "10009",
      "OFFICE": "K0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10010",
      "OFFICE": "GR",
      "START": "1645-01-10",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10010",
      "OFFICE": "K0",
      "START": "1645-05-22",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10011",
      "OFFICE": "GR",
      "START": "1640-06-18",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10011",
      "OFFICE": "K0",
      "START": "1645-10-05",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10011",
      "OFFICE": "RHR",
      "START": "1637-04-15",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10015",
      "OFFICE": "K",
      "START": "1637-04-17",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10015",
      "OFFICE": "K0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10016",
      "OFFICE": "GR",
      "START": "1637-04-02",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10016",
      "OFFICE": "K",
      "START": "1635",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10016",
      "OFFICE": "K0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10017",
      "OFFICE": "GR",
      "START": "1645-02-24",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10017",
      "OFFICE": "K",
      "START": "1635",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10017",
      "OFFICE": "K0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10019",
      "OFFICE": "GR",
      "START": "1649-12-01",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10019",
      "OFFICE": "RHP",
      "START": "1648-03-27",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10019",
      "OFFICE": "RHR",
      "START": "1637-04-15",
      "END": "1648-03-27"
  },
  {
      "COURT": "F3",
      "ID": "10020",
      "OFFICE": "K",
      "START": "1654-08-02",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10020",
      "OFFICE": "RHR",
      "START": "1653-03-21",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10021",
      "OFFICE": "GR",
      "START": "1651-02-20",
      "END": "1655-11-01"
  },
  {
      "COURT": "F3",
      "ID": "10021",
      "OFFICE": "OHM",
      "START": "1651-03-05",
      "END": "1655-11-01"
  },
  {
      "COURT": "F3",
      "ID": "10022",
      "OFFICE": "GR",
      "START": "1637-03-24",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10023",
      "OFFICE": "GR",
      "START": "1637-03-24",
      "END": "1652-01-19"
  },
  {
      "COURT": "F3",
      "ID": "10023",
      "OFFICE": "K0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10024",
      "OFFICE": "GR",
      "START": "1637-04-02",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10024",
      "OFFICE": "K0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10025",
      "OFFICE": "Fs",
      "START": "1639-02-07",
      "END": "1639-06-11"
  },
  {
      "COURT": "F3",
      "ID": "10025",
      "OFFICE": "Ms",
      "START": "1639-06-11",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10025",
      "OFFICE": "Ts",
      "START": "1638-06-15",
      "END": "1639-02-07"
  },
  {
      "COURT": "F3",
      "ID": "10026",
      "OFFICE": "GR",
      "START": "1637-04-02",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10027",
      "OFFICE": "GR",
      "START": "1655-07-02",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10027",
      "OFFICE": "HKrR",
      "START": "1639-07-13",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10027",
      "OFFICE": "HKrVP",
      "START": "1650-02-12",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10027",
      "OFFICE": "K",
      "START": "1634",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10027",
      "OFFICE": "TraHM",
      "START": "1634-03-15",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10028",
      "OFFICE": "K",
      "START": "1626",
      "END": "1626-07-31"
  },
  {
      "COURT": "F3",
      "ID": "10029",
      "OFFICE": "K",
      "START": "1625",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10029",
      "OFFICE": "K0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10031",
      "OFFICE": "GR",
      "START": "1647-08-08",
      "END": "1655-02-19"
  },
  {
      "COURT": "F3",
      "ID": "10031",
      "OFFICE": "K",
      "START": "1622",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10031",
      "OFFICE": "K0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10031",
      "OFFICE": "OK",
      "START": "1651-03-07",
      "END": "1655-02-19"
  },
  {
      "COURT": "F3",
      "ID": "10031",
      "OFFICE": "OStallM",
      "START": "",
      "END": "1651-03-07"
  },
  {
      "COURT": "F3",
      "ID": "10034",
      "OFFICE": "GR",
      "START": "1646-09-17",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10034",
      "OFFICE": "K0",
      "START": "1648-07-14",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10036",
      "OFFICE": "K",
      "START": "1648-12-04",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10037",
      "OFFICE": "GR",
      "START": "1637-04-02",
      "END": "1637-10-18"
  },
  {
      "COURT": "F3",
      "ID": "10037",
      "OFFICE": "RHVP",
      "START": "1637-04-15",
      "END": "1637-09-18"
  },
  {
      "COURT": "F3",
      "ID": "10039",
      "OFFICE": "GR",
      "START": "1637-04-27",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10041",
      "OFFICE": "GR",
      "START": "1637-05-28",
      "END": "1638-08-24"
  },
  {
      "COURT": "F3",
      "ID": "10041",
      "OFFICE": "K",
      "START": "1635",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10041",
      "OFFICE": "K0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10042",
      "OFFICE": "HKrR",
      "START": "1637-04-02",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10043",
      "OFFICE": "GR",
      "START": "1639-11-30",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10043",
      "OFFICE": "K0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10044",
      "OFFICE": "GR",
      "START": "1640-07-01",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10044",
      "OFFICE": "RHP",
      "START": "1637-11-23",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10044",
      "OFFICE": "RHR",
      "START": "1637-04-15",
      "END": "1637-11-23"
  },
  {
      "COURT": "F3",
      "ID": "10045",
      "OFFICE": "GR",
      "START": "1653-08-02",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10045",
      "OFFICE": "K",
      "START": "1637-01-02",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10045",
      "OFFICE": "RHR",
      "START": "1640-06-01",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10046",
      "OFFICE": "GR",
      "START": "1637-03-24",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10046",
      "OFFICE": "K",
      "START": "1636",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10046",
      "OFFICE": "K0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10047",
      "OFFICE": "GR",
      "START": "1637-03-24",
      "END": "1650-06-12"
  },
  {
      "COURT": "F3",
      "ID": "10048",
      "OFFICE": "GR",
      "START": "1644-09-10",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10048",
      "OFFICE": "K0",
      "START": "1649-01-29",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10049",
      "OFFICE": "GR",
      "START": "1637-04-02",
      "END": "1649-12-31"
  },
  {
      "COURT": "F3",
      "ID": "10049",
      "OFFICE": "HKrP",
      "START": "1637-04-02",
      "END": "1649-12-31"
  },
  {
      "COURT": "F3",
      "ID": "10053",
      "OFFICE": "GR",
      "START": "1637-09-01",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10057",
      "OFFICE": "K",
      "START": "1631",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10058",
      "OFFICE": "GR",
      "START": "1647-01-22",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10058",
      "OFFICE": "HKrP",
      "START": "1650-02-12",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10058",
      "OFFICE": "K",
      "START": "1635",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10059",
      "OFFICE": "K",
      "START": "1646-08-04",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10061",
      "OFFICE": "K",
      "START": "1643-05-24",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10061",
      "OFFICE": "Ms",
      "START": "1643-02-19",
      "END": "1643-05-24"
  },
  {
      "COURT": "F3",
      "ID": "10061",
      "OFFICE": "RHR",
      "START": "1645-10-20",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10062",
      "OFFICE": "K",
      "START": "1627",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10063",
      "OFFICE": "Ms",
      "START": "1655-07-20",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10064",
      "OFFICE": "K",
      "START": "1639-05-04",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10065",
      "OFFICE": "K",
      "START": "1652-08-18",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10065",
      "OFFICE": "Ts",
      "START": "1641-02-10",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10066",
      "OFFICE": "K",
      "START": "1654-08-17",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10066",
      "OFFICE": "Ms",
      "START": "1646-10-15",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10066",
      "OFFICE": "RHR",
      "START": "1655-02-19",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10067",
      "OFFICE": "K",
      "START": "1653-02-05",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10069",
      "OFFICE": "K",
      "START": "1646-02-11",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10071",
      "OFFICE": "RHR",
      "START": "1654-11-13",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10072",
      "OFFICE": "GR",
      "START": "1640-12-23",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10072",
      "OFFICE": "HarHM",
      "START": "1639-02-15",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10072",
      "OFFICE": "K",
      "START": "1639-02-01",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10073",
      "OFFICE": "K0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10076",
      "OFFICE": "GR",
      "START": "1645-01-01",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10076",
      "OFFICE": "K",
      "START": "1625-01-01",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10076",
      "OFFICE": "OK",
      "START": "1635-07-01",
      "END": "1651-01-17"
  },
  {
      "COURT": "F3",
      "ID": "10076",
      "OFFICE": "RHR",
      "START": "1637-04-15",
      "END": "1645-01-01"
  },
  {
      "COURT": "F3",
      "ID": "10077",
      "OFFICE": "GR",
      "START": "1653-07-07",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10077",
      "OFFICE": "HKrR",
      "START": "1643-12-20",
      "END": "1653-07-07"
  },
  {
      "COURT": "F3",
      "ID": "10077",
      "OFFICE": "K",
      "START": "1643-12-18",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10078",
      "OFFICE": "GR",
      "START": "1654-06-26",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10078",
      "OFFICE": "K",
      "START": "1640-04-15",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10078",
      "OFFICE": "OK",
      "START": "1655-02-23",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10078",
      "OFFICE": "OStallM",
      "START": "1654-02-01",
      "END": "1655-03-01"
  },
  {
      "COURT": "F3",
      "ID": "10083",
      "OFFICE": "GR",
      "START": "1655-07-02",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10083",
      "OFFICE": "K",
      "START": "1645-10-09",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10084",
      "OFFICE": "K",
      "START": "1634",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10084",
      "OFFICE": "RHR",
      "START": "1637-12-01",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10085",
      "OFFICE": "K",
      "START": "1649-03-21",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10089",
      "OFFICE": "RHP",
      "START": "1637-04-15",
      "END": "1640-12-20"
  },
  {
      "COURT": "F3",
      "ID": "10091",
      "OFFICE": "GR",
      "START": "1656-01-12",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10091",
      "OFFICE": "K0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10091",
      "OFFICE": "OHMar",
      "START": "1634-05-01",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10092",
      "OFFICE": "Ms",
      "START": "1655-06-07",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10093",
      "OFFICE": "GR",
      "START": "1653-07-07",
      "END": "1653-11-25"
  },
  {
      "COURT": "F3",
      "ID": "10093",
      "OFFICE": "K",
      "START": "1637-04-05",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10093",
      "OFFICE": "OFalkM",
      "START": "1637-04-02",
      "END": "1651-03-09"
  },
  {
      "COURT": "F3",
      "ID": "10093",
      "OFFICE": "OStallM",
      "START": "1651-03-09",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10095",
      "OFFICE": "GR",
      "START": "1654-07-21",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10095",
      "OFFICE": "K",
      "START": "1651-01-30",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10096",
      "OFFICE": "K",
      "START": "1640-09-20",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10096",
      "OFFICE": "OFalkM",
      "START": "1642-11-01",
      "END": "1655-03-01"
  },
  {
      "COURT": "F3",
      "ID": "10096",
      "OFFICE": "OStallM",
      "START": "1655-02-23",
      "END": "1658-06-30"
  },
  {
      "COURT": "F3",
      "ID": "10097",
      "OFFICE": "RHR",
      "START": "1637-04-15",
      "END": "1639-07-30"
  },
  {
      "COURT": "F3",
      "ID": "10104",
      "OFFICE": "K",
      "START": "1615",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10106",
      "OFFICE": "GR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10112",
      "OFFICE": "GR",
      "START": "1648-06-07",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10120",
      "OFFICE": "HKaP",
      "START": "1656-10-12",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10120",
      "OFFICE": "HKaR",
      "START": "1650-04-23",
      "END": "1651-03-25"
  },
  {
      "COURT": "F3",
      "ID": "10120",
      "OFFICE": "HKaVP",
      "START": "1651-03-25",
      "END": "1656-10-12"
  },
  {
      "COURT": "F3",
      "ID": "10120",
      "OFFICE": "K",
      "START": "1650-04-25",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10121",
      "OFFICE": "GR",
      "START": "1638-05-00",
      "END": "1651-11-12"
  },
  {
      "COURT": "F3",
      "ID": "10121",
      "OFFICE": "K",
      "START": "1625",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10121",
      "OFFICE": "K0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10122",
      "OFFICE": "GR",
      "START": "1644-08-06",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10122",
      "OFFICE": "HKaP",
      "START": "1637-03-25",
      "END": "1648-07-31"
  },
  {
      "COURT": "F3",
      "ID": "10122",
      "OFFICE": "K",
      "START": "1629",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10122",
      "OFFICE": "K0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10122",
      "OFFICE": "Ms",
      "START": "1628-11-01",
      "END": "1629-01-15"
  },
  {
      "COURT": "F3",
      "ID": "10124",
      "OFFICE": "GR",
      "START": "1653-09-09",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10124",
      "OFFICE": "K",
      "START": "1646-09-22",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10125",
      "OFFICE": "K",
      "START": "1640-07-30",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10125",
      "OFFICE": "Ms",
      "START": "1637-05-17",
      "END": "1640-07-30"
  },
  {
      "COURT": "F3",
      "ID": "10129",
      "OFFICE": "K",
      "START": "1643-01-02",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10129",
      "OFFICE": "RHR",
      "START": "1645-01-10",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10136",
      "OFFICE": "K",
      "START": "1637",
      "END": "1650-11-30"
  },
  {
      "COURT": "F3",
      "ID": "10140",
      "OFFICE": "Fs",
      "START": "1639-04-21",
      "END": "1639-10-01"
  },
  {
      "COURT": "F3",
      "ID": "10140",
      "OFFICE": "K",
      "START": "1649-07-31",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10140",
      "OFFICE": "Ms",
      "START": "1639-10-01",
      "END": "1641-12-09"
  },
  {
      "COURT": "F3",
      "ID": "10140",
      "OFFICE": "OTs",
      "START": "1641-12-09",
      "END": "1649-07-31"
  },
  {
      "COURT": "F3",
      "ID": "10141",
      "OFFICE": "GR",
      "START": "1637-03-24",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10142",
      "OFFICE": "K",
      "START": "1651-01-01",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10144",
      "OFFICE": "RHR",
      "START": "1637-12-24",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10145",
      "OFFICE": "K",
      "START": "1637-04-06",
      "END": "1649-07-29"
  },
  {
      "COURT": "F3",
      "ID": "10146",
      "OFFICE": "GR",
      "START": "1655-02-27",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10146",
      "OFFICE": "HarHM",
      "START": "1637-10-01",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10146",
      "OFFICE": "HKrR",
      "START": "1637-04-02",
      "END": "1643-05-15"
  },
  {
      "COURT": "F3",
      "ID": "10147",
      "OFFICE": "HC",
      "START": "1656-09-03",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10147",
      "OFFICE": "K",
      "START": "1653-12-21",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10147",
      "OFFICE": "RHR",
      "START": "1648-12-01",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10148",
      "OFFICE": "K",
      "START": "1640-06-19",
      "END": "1646-01-31"
  },
  {
      "COURT": "F3",
      "ID": "10148",
      "OFFICE": "OTs",
      "START": "1639-09-22",
      "END": "1640-06-19"
  },
  {
      "COURT": "F3",
      "ID": "10149",
      "OFFICE": "K",
      "START": "1647-03-10",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10151",
      "OFFICE": "Ms",
      "START": "1636-11-04",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10151",
      "OFFICE": "Ts",
      "START": "1634-05-01",
      "END": "1636-11-04"
  },
  {
      "COURT": "F3",
      "ID": "10152",
      "OFFICE": "Ms",
      "START": "1635-05-01",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10154",
      "OFFICE": "K",
      "START": "1648-11-23",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10155",
      "OFFICE": "K",
      "START": "1639-05-05",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10155",
      "OFFICE": "Ms",
      "START": "1633-05-17",
      "END": "1637-04-24"
  },
  {
      "COURT": "F3",
      "ID": "10155",
      "OFFICE": "OTs",
      "START": "1637-04-24",
      "END": "1639-05-05"
  },
  {
      "COURT": "F3",
      "ID": "10156",
      "OFFICE": "K",
      "START": "1651-06-23",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10156",
      "OFFICE": "Ms",
      "START": "1651-03-11",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10157",
      "OFFICE": "K",
      "START": "1646-04-22",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10158",
      "OFFICE": "K",
      "START": "1639-06-08",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10159",
      "OFFICE": "K",
      "START": "1650-01-12",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10160",
      "OFFICE": "K",
      "START": "1655-02-10",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10164",
      "OFFICE": "K",
      "START": "1640-12-15",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10164",
      "OFFICE": "Ms",
      "START": "1640-10-03",
      "END": "1640-12-15"
  },
  {
      "COURT": "F3",
      "ID": "10164",
      "OFFICE": "RHR",
      "START": "1646-07-09",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10165",
      "OFFICE": "GR",
      "START": "1653-07-07",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10165",
      "OFFICE": "HKaP",
      "START": "1648-08-01",
      "END": "1656"
  },
  {
      "COURT": "F3",
      "ID": "10165",
      "OFFICE": "HKaR",
      "START": "1640-03-01",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10165",
      "OFFICE": "HKaVP",
      "START": "1644-09-01",
      "END": "1648-08-01"
  },
  {
      "COURT": "F3",
      "ID": "10165",
      "OFFICE": "K",
      "START": "1642-12-31",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10166",
      "OFFICE": "Ms",
      "START": "1651-09-20",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10166",
      "OFFICE": "RHR",
      "START": "1655-08-26",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10167",
      "OFFICE": "Ms",
      "START": "1636-03-13",
      "END": "1640-09-23"
  },
  {
      "COURT": "F3",
      "ID": "10167",
      "OFFICE": "OTs",
      "START": "1640-09-23",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10168",
      "OFFICE": "GR",
      "START": "1656-01-13",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10168",
      "OFFICE": "K",
      "START": "1647-06-14",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10168",
      "OFFICE": "RHR",
      "START": "1645-07-11",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10168",
      "OFFICE": "TraHM",
      "START": "1651-01-01",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10169",
      "OFFICE": "GR",
      "START": "1655-08-04",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10169",
      "OFFICE": "K0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10171",
      "OFFICE": "Ms",
      "START": "1639-12-01",
      "END": "1649-09-25"
  },
  {
      "COURT": "F3",
      "ID": "10171",
      "OFFICE": "OTs",
      "START": "1649-09-25",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10171",
      "OFFICE": "Ts",
      "START": "1636-12-22",
      "END": "1639-12-01"
  },
  {
      "COURT": "F3",
      "ID": "10172",
      "OFFICE": "Ms",
      "START": "1649-05-29",
      "END": "1656-04-19"
  },
  {
      "COURT": "F3",
      "ID": "10172",
      "OFFICE": "OTs",
      "START": "1656-04-19",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10173",
      "OFFICE": "K",
      "START": "1637-12-30",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10174",
      "OFFICE": "K",
      "START": "1646-09-29",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10174",
      "OFFICE": "Ms",
      "START": "1636-03-26",
      "END": "1646-09-29"
  },
  {
      "COURT": "F3",
      "ID": "10175",
      "OFFICE": "K",
      "START": "1653-05-12",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10176",
      "OFFICE": "GR",
      "START": "1652-11-24",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10176",
      "OFFICE": "K",
      "START": "1639-05-04",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10176",
      "OFFICE": "Ms",
      "START": "1636-12-15",
      "END": "1637-04-20"
  },
  {
      "COURT": "F3",
      "ID": "10176",
      "OFFICE": "OSilK",
      "START": "1637-04-20",
      "END": "1639-05-04"
  },
  {
      "COURT": "F3",
      "ID": "10177",
      "OFFICE": "K",
      "START": "1641-07-07",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10178",
      "OFFICE": "K",
      "START": "1650-03-24",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10179",
      "OFFICE": "Ms",
      "START": "1637-08-01",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10180",
      "OFFICE": "K",
      "START": "1644-03-20",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10180",
      "OFFICE": "Ms",
      "START": "1641-09-03",
      "END": "1642-10-15"
  },
  {
      "COURT": "F3",
      "ID": "10180",
      "OFFICE": "OSilK",
      "START": "1642-10-15",
      "END": "1644-03-20"
  },
  {
      "COURT": "F3",
      "ID": "10181",
      "OFFICE": "K",
      "START": "1647-06-10",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10181",
      "OFFICE": "Ms",
      "START": "1637-08-01",
      "END": "1647-06-10"
  },
  {
      "COURT": "F3",
      "ID": "10182",
      "OFFICE": "K",
      "START": "1641-07-07",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10182",
      "OFFICE": "Ms",
      "START": "1639-02-15",
      "END": "1639-09-22"
  },
  {
      "COURT": "F3",
      "ID": "10182",
      "OFFICE": "OSilK",
      "START": "1639-09-22",
      "END": "1641-07-07"
  },
  {
      "COURT": "F3",
      "ID": "10183",
      "OFFICE": "Fs",
      "START": "1637-04-01",
      "END": "1639-01-25"
  },
  {
      "COURT": "F3",
      "ID": "10183",
      "OFFICE": "K",
      "START": "1652-05-30",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10183",
      "OFFICE": "Ms",
      "START": "1639-01-25",
      "END": "1652-05-30"
  },
  {
      "COURT": "F3",
      "ID": "10184",
      "OFFICE": "Fs",
      "START": "1639-04-21",
      "END": "1639-10-01"
  },
  {
      "COURT": "F3",
      "ID": "10184",
      "OFFICE": "Ms",
      "START": "1639-10-01",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10185",
      "OFFICE": "K",
      "START": "1644-08-28",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10185",
      "OFFICE": "Ms",
      "START": "1642-04-02",
      "END": "1644-08-28"
  },
  {
      "COURT": "F3",
      "ID": "10186",
      "OFFICE": "HKaR",
      "START": "1646-08-09",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10186",
      "OFFICE": "K",
      "START": "1645-08-02",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10186",
      "OFFICE": "Ms",
      "START": "1640-05-16",
      "END": "1644-05-23"
  },
  {
      "COURT": "F3",
      "ID": "10186",
      "OFFICE": "OK\u00fcM",
      "START": "1646-10-01",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10186",
      "OFFICE": "OSilK",
      "START": "1644-05-23",
      "END": "1647-08-20"
  },
  {
      "COURT": "F3",
      "ID": "10187",
      "OFFICE": "K",
      "START": "1642-04-29",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10187",
      "OFFICE": "Ms",
      "START": "1640-12-12",
      "END": "1642-05-11"
  },
  {
      "COURT": "F3",
      "ID": "10189",
      "OFFICE": "K",
      "START": "1645-04-12",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10189",
      "OFFICE": "Ms",
      "START": "1644-11-06",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10191",
      "OFFICE": "Fs",
      "START": "1642-06-20",
      "END": "1644-12-09"
  },
  {
      "COURT": "F3",
      "ID": "10191",
      "OFFICE": "Ms",
      "START": "1644-12-09",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10191",
      "OFFICE": "Ts",
      "START": "1640-11-01",
      "END": "1642-06-20"
  },
  {
      "COURT": "F3",
      "ID": "10192",
      "OFFICE": "K",
      "START": "1648-11-08",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10192",
      "OFFICE": "Ms",
      "START": "1646-03-29",
      "END": "1648-11-08"
  },
  {
      "COURT": "F3",
      "ID": "10193",
      "OFFICE": "K",
      "START": "1648-08-08",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10195",
      "OFFICE": "K",
      "START": "1647-06-17",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10195",
      "OFFICE": "Ms",
      "START": "1646-10-21",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10196",
      "OFFICE": "K",
      "START": "1625",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10197",
      "OFFICE": "K",
      "START": "1638-01-17",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10198",
      "OFFICE": "K",
      "START": "1646-09-21",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10199",
      "OFFICE": "K",
      "START": "1644-02-13",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10201",
      "OFFICE": "Ms",
      "START": "1646-11-27",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10202",
      "OFFICE": "K",
      "START": "1655-04-14",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10203",
      "OFFICE": "K",
      "START": "1646-09-24",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10204",
      "OFFICE": "Fs",
      "START": "1642-12-22",
      "END": "1643-09-01"
  },
  {
      "COURT": "F3",
      "ID": "10204",
      "OFFICE": "K",
      "START": "1643-09-01",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10205",
      "OFFICE": "K",
      "START": "1649-04-18",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10205",
      "OFFICE": "Ms",
      "START": "1646-12-22",
      "END": "1649-04-20"
  },
  {
      "COURT": "F3",
      "ID": "10206",
      "OFFICE": "K",
      "START": "1652-04-07",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10206",
      "OFFICE": "Ms",
      "START": "1651-04-23",
      "END": "1652-04-07"
  },
  {
      "COURT": "F3",
      "ID": "10207",
      "OFFICE": "K",
      "START": "1647-06-20",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10207",
      "OFFICE": "Ms",
      "START": "1647-02-22",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10208",
      "OFFICE": "K",
      "START": "1648-08-28",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10208",
      "OFFICE": "Ms",
      "START": "1647-06-14",
      "END": "1648-08-28"
  },
  {
      "COURT": "F3",
      "ID": "10210",
      "OFFICE": "K",
      "START": "1654-08-02",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10211",
      "OFFICE": "K",
      "START": "1615",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10212",
      "OFFICE": "K",
      "START": "1628",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10212",
      "OFFICE": "RHVP",
      "START": "1638-10-06",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10213",
      "OFFICE": "K",
      "START": "1637",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10213",
      "OFFICE": "RHR",
      "START": "1638-07-01",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10221",
      "OFFICE": "K",
      "START": "1634",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10222",
      "OFFICE": "K",
      "START": "1653-03-02",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10223",
      "OFFICE": "RHR",
      "START": "1653-03-21",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10255",
      "OFFICE": "K",
      "START": "1637-04-11",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10256",
      "OFFICE": "K",
      "START": "1625-11-01",
      "END": "1645-03-05"
  },
  {
      "COURT": "F3",
      "ID": "10260",
      "OFFICE": "RHR",
      "START": "1656-07-01",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10295",
      "OFFICE": "K0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10298",
      "OFFICE": "K",
      "START": "1635",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10302",
      "OFFICE": "GR",
      "START": "1642-04-25",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10303",
      "OFFICE": "RHR",
      "START": "1653-07-14",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10310",
      "OFFICE": "K",
      "START": "1652-05-30",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10310",
      "OFFICE": "RHR",
      "START": "1652-10-16",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10316",
      "OFFICE": "K",
      "START": "1655-03-14",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10324",
      "OFFICE": "Ms",
      "START": "1647-07-14",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10325",
      "OFFICE": "Ts",
      "START": "1650-10-20",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10327",
      "OFFICE": "Fs",
      "START": "1642-06-20",
      "END": "1647-08-21"
  },
  {
      "COURT": "F3",
      "ID": "10327",
      "OFFICE": "K",
      "START": "1652-04-03",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10327",
      "OFFICE": "OSilK",
      "START": "1647-08-21",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10327",
      "OFFICE": "Ts",
      "START": "1641-01-18",
      "END": "1642-06-20"
  },
  {
      "COURT": "F3",
      "ID": "10328",
      "OFFICE": "Fs",
      "START": "1648-03-09",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10350",
      "OFFICE": "HarHM",
      "START": "1656-08-16",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10350",
      "OFFICE": "K",
      "START": "1651-03-28",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10356",
      "OFFICE": "K",
      "START": "1644-06-30",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10359",
      "OFFICE": "Ms",
      "START": "1648-06-24",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10359",
      "OFFICE": "Ts",
      "START": "1645-10-15",
      "END": "1648-06-24"
  },
  {
      "COURT": "F3",
      "ID": "10361",
      "OFFICE": "Ms",
      "START": "1656-09-24",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10365",
      "OFFICE": "K",
      "START": "1656-09-23",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10365",
      "OFFICE": "Ts",
      "START": "1635-07-08",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10369",
      "OFFICE": "K",
      "START": "1638-08-25",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10369",
      "OFFICE": "K0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10378",
      "OFFICE": "K",
      "START": "1656-09-05",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10379",
      "OFFICE": "Ms",
      "START": "1653-06-19",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10381",
      "OFFICE": "K",
      "START": "1645-10-29",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10381",
      "OFFICE": "Ts",
      "START": "1640-10-15",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10382",
      "OFFICE": "Fs",
      "START": "1652-11-05",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10382",
      "OFFICE": "Ts",
      "START": "1652-11-05",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10383",
      "OFFICE": "K",
      "START": "1643-05-04",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10384",
      "OFFICE": "K",
      "START": "1644-08-28",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10388",
      "OFFICE": "K",
      "START": "1648-11-08",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10388",
      "OFFICE": "Ms",
      "START": "1646-09-25",
      "END": "1648-11-08"
  },
  {
      "COURT": "F3",
      "ID": "10388",
      "OFFICE": "RHR",
      "START": "1651-01-19",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10396",
      "OFFICE": "Ts",
      "START": "1637-04-27",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10397",
      "OFFICE": "K",
      "START": "1649-03-14",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10398",
      "OFFICE": "K",
      "START": "1643-01-18",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10398",
      "OFFICE": "RHR",
      "START": "1645-06-16",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10409",
      "OFFICE": "Ts",
      "START": "1650-03-05",
      "END": "1651-06-20"
  },
  {
      "COURT": "F3",
      "ID": "10409",
      "OFFICE": "USilK",
      "START": "1651-06-20",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10412",
      "OFFICE": "Ts",
      "START": "1648-08-01",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10417",
      "OFFICE": "Ts",
      "START": "1634-09-15",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10419",
      "OFFICE": "RHR",
      "START": "1641-07-15",
      "END": "1642-12-31"
  },
  {
      "COURT": "F3",
      "ID": "10425",
      "OFFICE": "Ts",
      "START": "1649-11-19",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10426",
      "OFFICE": "K",
      "START": "1656-08-12",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10426",
      "OFFICE": "Ms",
      "START": "1656-04-19",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10431",
      "OFFICE": "K",
      "START": "1615",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10431",
      "OFFICE": "K0",
      "START": "1646",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10432",
      "OFFICE": "Ms",
      "START": "1656-09-24",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10433",
      "OFFICE": "K",
      "START": "1653-05-11",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10434",
      "OFFICE": "K",
      "START": "1650-02-18",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10434",
      "OFFICE": "Ms",
      "START": "1649-04-04",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10440",
      "OFFICE": "K",
      "START": "1642-04-14",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10455",
      "OFFICE": "K",
      "START": "1646-10-04",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10455",
      "OFFICE": "Ms",
      "START": "1646-03-25",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10456",
      "OFFICE": "Fs",
      "START": "1639-12-01",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10456",
      "OFFICE": "Ts",
      "START": "1639-04-21",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10461",
      "OFFICE": "Ts",
      "START": "1639-11-01",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10462",
      "OFFICE": "K",
      "START": "1656-09-20",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10462",
      "OFFICE": "Ms",
      "START": "1652-08-11",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10484",
      "OFFICE": "HKaR",
      "START": "1637-04-02",
      "END": "1646-09-30"
  },
  {
      "COURT": "F3",
      "ID": "10484",
      "OFFICE": "OK\u00fcM",
      "START": "1634-03-01",
      "END": "1646-09-30"
  },
  {
      "COURT": "F3",
      "ID": "10486",
      "OFFICE": "Fs",
      "START": "1639-12-01",
      "END": "1648-05-25"
  },
  {
      "COURT": "F3",
      "ID": "10486",
      "OFFICE": "Ms",
      "START": "1648-05-25",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10486",
      "OFFICE": "Ts",
      "START": "1639-04-21",
      "END": "1639-12-01"
  },
  {
      "COURT": "F3",
      "ID": "10491",
      "OFFICE": "K",
      "START": "1646-10-04",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10491",
      "OFFICE": "Ms",
      "START": "1646-03-26",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10492",
      "OFFICE": "K",
      "START": "1639-11-29",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10493",
      "OFFICE": "K",
      "START": "1652-09-29",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10495",
      "OFFICE": "K",
      "START": "1652-09-22",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10498",
      "OFFICE": "K",
      "START": "1635",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10498",
      "OFFICE": "K0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10504",
      "OFFICE": "GR",
      "START": "1655-07-03",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10504",
      "OFFICE": "K",
      "START": "1651-02-28",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10508",
      "OFFICE": "K",
      "START": "1653-05-25",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10510",
      "OFFICE": "K",
      "START": "1653-05-26",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10513",
      "OFFICE": "K",
      "START": "1653-05-25",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10516",
      "OFFICE": "K",
      "START": "1625",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10518",
      "OFFICE": "HKrR",
      "START": "1637-04-02",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10519",
      "OFFICE": "K",
      "START": "1647-01-01",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10533",
      "OFFICE": "K",
      "START": "1654-07-17",
      "END": "1657-03-31"
  },
  {
      "COURT": "F3",
      "ID": "10536",
      "OFFICE": "K",
      "START": "1649-05-25",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10536",
      "OFFICE": "Ts",
      "START": "1646-12-10",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10537",
      "OFFICE": "Ts",
      "START": "1648-08-02",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10538",
      "OFFICE": "K",
      "START": "1637-01-03",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10541",
      "OFFICE": "K",
      "START": "1650-06-15",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10541",
      "OFFICE": "Ms",
      "START": "1650-03-22",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10543",
      "OFFICE": "K",
      "START": "1634",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10544",
      "OFFICE": "K",
      "START": "1655-03-17",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10545",
      "OFFICE": "Ts",
      "START": "1641-12-09",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10546",
      "OFFICE": "Ts",
      "START": "1635-06-10",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10549",
      "OFFICE": "Ms",
      "START": "1654-10-17",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10552",
      "OFFICE": "K",
      "START": "1651-11-11",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10552",
      "OFFICE": "Ms",
      "START": "1651-04-05",
      "END": "1651-11-11"
  },
  {
      "COURT": "F3",
      "ID": "10553",
      "OFFICE": "Ts",
      "START": "1637-01-21",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10555",
      "OFFICE": "K",
      "START": "1652-01-07",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10560",
      "OFFICE": "K",
      "START": "1656-09-20",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10566",
      "OFFICE": "Ms",
      "START": "1636-03-16",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10576",
      "OFFICE": "Ms",
      "START": "1635-05-17",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10578",
      "OFFICE": "RHR",
      "START": "1637-04-15",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10580",
      "OFFICE": "RHR",
      "START": "1637-04-15",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10582",
      "OFFICE": "HKrR",
      "START": "1637-04-02",
      "END": "1646-06-01"
  },
  {
      "COURT": "F3",
      "ID": "10604",
      "OFFICE": "K",
      "START": "1640-09-12",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10605",
      "OFFICE": "K",
      "START": "1650-02-07",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10606",
      "OFFICE": "K",
      "START": "1655-03-01",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10620",
      "OFFICE": "Ts",
      "START": "1652-04-15",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10626",
      "OFFICE": "HKaR",
      "START": "1647-08-26",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10627",
      "OFFICE": "K",
      "START": "1620",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10628",
      "OFFICE": "K",
      "START": "1655-03-07",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10632",
      "OFFICE": "K",
      "START": "1652-04-08",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10632",
      "OFFICE": "Ms",
      "START": "1651-03-29",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10633",
      "OFFICE": "Fs",
      "START": "1651-03-29",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10633",
      "OFFICE": "K",
      "START": "1654-08-17",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10638",
      "OFFICE": "K",
      "START": "1648-12-31",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10638",
      "OFFICE": "Ms",
      "START": "1648-10-10",
      "END": "1649-01-01"
  },
  {
      "COURT": "F3",
      "ID": "10639",
      "OFFICE": "K",
      "START": "1653-11-18",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10639",
      "OFFICE": "Ms",
      "START": "1649-02-04",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10643",
      "OFFICE": "K",
      "START": "1649-11-23",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10643",
      "OFFICE": "Ms",
      "START": "1649-02-18",
      "END": "1649-11-23"
  },
  {
      "COURT": "F3",
      "ID": "10648",
      "OFFICE": "K",
      "START": "1657-02-28",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10648",
      "OFFICE": "Ms",
      "START": "1649-12-07",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10648",
      "OFFICE": "Ts",
      "START": "1642-10-06",
      "END": "1649-12-07"
  },
  {
      "COURT": "F3",
      "ID": "10649",
      "OFFICE": "Ms",
      "START": "1649-12-20",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10659",
      "OFFICE": "K",
      "START": "1655-12-10",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10659",
      "OFFICE": "Ms",
      "START": "1651-05-27",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10664",
      "OFFICE": "Ms",
      "START": "1651-04-24",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10668",
      "OFFICE": "K",
      "START": "1648-12-12",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10670",
      "OFFICE": "K",
      "START": "1657-02-23",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10671",
      "OFFICE": "K",
      "START": "1651-08-16",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10679",
      "OFFICE": "K",
      "START": "1652-01-21",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10681",
      "OFFICE": "K",
      "START": "1653-03-23",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10682",
      "OFFICE": "K",
      "START": "1635",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10682",
      "OFFICE": "K0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10687",
      "OFFICE": "RHR",
      "START": "1637-04-15",
      "END": "1648-04-01"
  },
  {
      "COURT": "F3",
      "ID": "10687",
      "OFFICE": "RHVP",
      "START": "1648-04-01",
      "END": "1648-11-15"
  },
  {
      "COURT": "F3",
      "ID": "10690",
      "OFFICE": "K",
      "START": "1646-09-05",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10691",
      "OFFICE": "Ms",
      "START": "1648-12-25",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10693",
      "OFFICE": "Ts",
      "START": "1638-06-15",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10699",
      "OFFICE": "K",
      "START": "1654-07-31",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10720",
      "OFFICE": "K",
      "START": "1655-03-21",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10722",
      "OFFICE": "K",
      "START": "1646-09-21",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10723",
      "OFFICE": "K",
      "START": "1655-06-05",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10723",
      "OFFICE": "Ms",
      "START": "1651-04-20",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10724",
      "OFFICE": "RHR",
      "START": "1637-04-15",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10725",
      "OFFICE": "K",
      "START": "1649-04-03",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10727",
      "OFFICE": "Ms",
      "START": "1648-08-02",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10729",
      "OFFICE": "Ts",
      "START": "1655-02-25",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10745",
      "OFFICE": "Ms",
      "START": "1656-05-15",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10751",
      "OFFICE": "K",
      "START": "1652-05-12",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10751",
      "OFFICE": "Ms",
      "START": "1646-05-25",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10751",
      "OFFICE": "Ts",
      "START": "1646-10-26",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10779",
      "OFFICE": "K",
      "START": "1653-09-21",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10780",
      "OFFICE": "Ts",
      "START": "1649-05-24",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10785",
      "OFFICE": "HKaR",
      "START": "1637-04-02",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10790",
      "OFFICE": "RHF",
      "START": "1637-05-01",
      "END": "1646-03-01"
  },
  {
      "COURT": "F3",
      "ID": "10791",
      "OFFICE": "RHF",
      "START": "1646-04-10",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10794",
      "OFFICE": "HVC",
      "START": "1625-06-01",
      "END": "1635-11-30"
  },
  {
      "COURT": "F3",
      "ID": "10796",
      "OFFICE": "GR",
      "START": "1640-06-18",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10796",
      "OFFICE": "HVC",
      "START": "1637-03-25",
      "END": "1656-08-31"
  },
  {
      "COURT": "F3",
      "ID": "10797",
      "OFFICE": "Ms",
      "START": "1635-07-08",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10798",
      "OFFICE": "RHR",
      "START": "1640-01-12",
      "END": "1641-07-12"
  },
  {
      "COURT": "F3",
      "ID": "10799",
      "OFFICE": "Ts",
      "START": "1654-09-05",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10803",
      "OFFICE": "K",
      "START": "1653-02-05",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10806",
      "OFFICE": "K",
      "START": "1652-02-01",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10807",
      "OFFICE": "Ts",
      "START": "1637-01-06",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10808",
      "OFFICE": "RHR",
      "START": "1640-08-10",
      "END": "1641-10-15"
  },
  {
      "COURT": "F3",
      "ID": "10809",
      "OFFICE": "RHR",
      "START": "1653-03-21",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10811",
      "OFFICE": "Fs",
      "START": "",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10811",
      "OFFICE": "Ts",
      "START": "1634-10-15",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10818",
      "OFFICE": "K",
      "START": "1655-04-11",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10820",
      "OFFICE": "K",
      "START": "1649-03-29",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10826",
      "OFFICE": "K",
      "START": "1653-06-17",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10828",
      "OFFICE": "Ms",
      "START": "1655-01-21",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10832",
      "OFFICE": "K",
      "START": "1654-11-12",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10833",
      "OFFICE": "K",
      "START": "1649-06-08",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10836",
      "OFFICE": "K",
      "START": "1649-07-19",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10839",
      "OFFICE": "K",
      "START": "1637",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10845",
      "OFFICE": "K",
      "START": "1644-03-20",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10849",
      "OFFICE": "Fs",
      "START": "1644-01-01",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10849",
      "OFFICE": "K",
      "START": "1652-01-09",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10851",
      "OFFICE": "K",
      "START": "1648-10-20",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10852",
      "OFFICE": "Ms",
      "START": "1652-03-05",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10852",
      "OFFICE": "Ts",
      "START": "1649-12-24",
      "END": "1652-03-05"
  },
  {
      "COURT": "F3",
      "ID": "10855",
      "OFFICE": "Ts",
      "START": "1654-09-05",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10858",
      "OFFICE": "K",
      "START": "1656-08-14",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10858",
      "OFFICE": "Ms",
      "START": "1652-09-07",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10859",
      "OFFICE": "Ts",
      "START": "1653-02-03",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10864",
      "OFFICE": "K",
      "START": "1655-08-20",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10865",
      "OFFICE": "Fs",
      "START": "1650-04-05",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10865",
      "OFFICE": "Ts",
      "START": "1649-12-24",
      "END": "1650-04-05"
  },
  {
      "COURT": "F3",
      "ID": "10882",
      "OFFICE": "HKrR",
      "START": "1637-04-02",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10886",
      "OFFICE": "K",
      "START": "1652-09-08",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10888",
      "OFFICE": "HKrR",
      "START": "1645-02-18",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10888",
      "OFFICE": "K",
      "START": "1645-07-22",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10894",
      "OFFICE": "K",
      "START": "1642-07-16",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10895",
      "OFFICE": "USilK",
      "START": "1636-01-15",
      "END": "1648-11-10"
  },
  {
      "COURT": "F3",
      "ID": "10898",
      "OFFICE": "K",
      "START": "1649-10-14",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10899",
      "OFFICE": "K",
      "START": "1648-04-28",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10901",
      "OFFICE": "K",
      "START": "1624",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10904",
      "OFFICE": "K",
      "START": "1649-07-19",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10906",
      "OFFICE": "Ts",
      "START": "1654-06-16",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10908",
      "OFFICE": "RHR",
      "START": "1637-04-15",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10910",
      "OFFICE": "GR",
      "START": "1656-03-28",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10915",
      "OFFICE": "K",
      "START": "1646-04-18",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10921",
      "OFFICE": "K",
      "START": "1644-01-25",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10926",
      "OFFICE": "Ts",
      "START": "1655-08-12",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10928",
      "OFFICE": "Ts",
      "START": "1637-07-23",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10929",
      "OFFICE": "Ts",
      "START": "1639-01-28",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10935",
      "OFFICE": "Ts",
      "START": "1637-04-29",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10936",
      "OFFICE": "K",
      "START": "1650-01-01",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10936",
      "OFFICE": "RHR",
      "START": "1653-03-21",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10937",
      "OFFICE": "K",
      "START": "1648-06-07",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10938",
      "OFFICE": "K",
      "START": "1656-04-25",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10939",
      "OFFICE": "Ts",
      "START": "1645-07-12",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10962",
      "OFFICE": "Ts",
      "START": "1651-03-11",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10967",
      "OFFICE": "K",
      "START": "1635",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10967",
      "OFFICE": "K0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10968",
      "OFFICE": "Ts",
      "START": "1652-04-06",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10973",
      "OFFICE": "K",
      "START": "1647-02-28",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10976",
      "OFFICE": "K",
      "START": "1656-09-20",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10981",
      "OFFICE": "K",
      "START": "1647-10-20",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10988",
      "OFFICE": "K",
      "START": "1650-04-04",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "10997",
      "OFFICE": "Ms",
      "START": "1648-06-08",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11001",
      "OFFICE": "HPfenM",
      "START": "1632-11-15",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11002",
      "OFFICE": "Ms",
      "START": "1654-03-21",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11002",
      "OFFICE": "Ts",
      "START": "1637-01-06",
      "END": "1654-03-21"
  },
  {
      "COURT": "F3",
      "ID": "11003",
      "OFFICE": "HPfenM",
      "START": "1635-10-25",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11003",
      "OFFICE": "HZM",
      "START": "1637-04-02",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11006",
      "OFFICE": "K",
      "START": "1625",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11006",
      "OFFICE": "K0",
      "START": "1646",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11007",
      "OFFICE": "K",
      "START": "1625",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11009",
      "OFFICE": "Ms",
      "START": "1650-09-04",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11011",
      "OFFICE": "K",
      "START": "1651-06-23",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11012",
      "OFFICE": "K",
      "START": "1654-10-06",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11042",
      "OFFICE": "RHR",
      "START": "1645-10-03",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11043",
      "OFFICE": "K",
      "START": "1626",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11043",
      "OFFICE": "K0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11044",
      "OFFICE": "K",
      "START": "1652-04-04",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11046",
      "OFFICE": "Ts",
      "START": "1638-06-05",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11047",
      "OFFICE": "Ts",
      "START": "1637-04-01",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11048",
      "OFFICE": "Fs",
      "START": "1637-05-16",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11048",
      "OFFICE": "K",
      "START": "1651-05-30",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11048",
      "OFFICE": "Ts",
      "START": "1636-10-30",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11049",
      "OFFICE": "Fs",
      "START": "1638-01-06",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11049",
      "OFFICE": "Ts",
      "START": "1636-10-30",
      "END": "1638-01-06"
  },
  {
      "COURT": "F3",
      "ID": "11051",
      "OFFICE": "HKaR",
      "START": "1648-01-01",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11052",
      "OFFICE": "HKaR",
      "START": "1649-01-10",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11052",
      "OFFICE": "HKaSek",
      "START": "1640-12-05",
      "END": "1649-01-10"
  },
  {
      "COURT": "F3",
      "ID": "11064",
      "OFFICE": "K",
      "START": "1622-07-01",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11081",
      "OFFICE": "HKrR",
      "START": "1637-04-02",
      "END": "1638-06-30"
  },
  {
      "COURT": "F3",
      "ID": "11083",
      "OFFICE": "Fs",
      "START": "1648-04-01",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11083",
      "OFFICE": "K",
      "START": "1648-12-12",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11087",
      "OFFICE": "K",
      "START": "1643-04-02",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11088",
      "OFFICE": "K",
      "START": "1653-11-10",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11089",
      "OFFICE": "Ts",
      "START": "1654-07-21",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11091",
      "OFFICE": "Ts",
      "START": "1653-12-05",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11092",
      "OFFICE": "HKaKon",
      "START": "1646-08-01",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11096",
      "OFFICE": "HKaReg",
      "START": "1637-04-02",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11097",
      "OFFICE": "HKaKon",
      "START": "1639-12-16",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11100",
      "OFFICE": "HKaR",
      "START": "1640-08-02",
      "END": "1647-04-11"
  },
  {
      "COURT": "F3",
      "ID": "11100",
      "OFFICE": "HKaSek",
      "START": "1637-04-02",
      "END": "1640-08-02"
  },
  {
      "COURT": "F3",
      "ID": "11101",
      "OFFICE": "HKaR",
      "START": "1640-08-03",
      "END": "1649-06-30"
  },
  {
      "COURT": "F3",
      "ID": "11102",
      "OFFICE": "HKaR",
      "START": "1643-11-18",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11104",
      "OFFICE": "HKaSek",
      "START": "1651-05-09",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11105",
      "OFFICE": "H",
      "START": "1642-04-04",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11105",
      "OFFICE": "HKaR",
      "START": "1654-04-30",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11105",
      "OFFICE": "R",
      "START": "1642-04-04",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11109",
      "OFFICE": "HKaR",
      "START": "1645-08-07",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11110",
      "OFFICE": "HKaR",
      "START": "1648-12-24",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11115",
      "OFFICE": "Ts",
      "START": "1635-07-08",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11121",
      "OFFICE": "K",
      "START": "1654-08-17",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11123",
      "OFFICE": "RHR",
      "START": "1652-09-23",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11124",
      "OFFICE": "Ts",
      "START": "1637-10-16",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11128",
      "OFFICE": "Ts",
      "START": "1653-06-27",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11135",
      "OFFICE": "Ts",
      "START": "1650-03-20",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11140",
      "OFFICE": "Ts",
      "START": "1648-08-02",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11142",
      "OFFICE": "K",
      "START": "1642-05-05",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11143",
      "OFFICE": "RHR",
      "START": "1637-04-15",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11145",
      "OFFICE": "HKaKon",
      "START": "",
      "END": "1637-04-02"
  },
  {
      "COURT": "F3",
      "ID": "11145",
      "OFFICE": "HKaSek",
      "START": "1637-04-02",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11146",
      "OFFICE": "K",
      "START": "1615",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11149",
      "OFFICE": "K",
      "START": "1622-04-01",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11155",
      "OFFICE": "K",
      "START": "1654-08-19",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11159",
      "OFFICE": "Ts",
      "START": "1654-04-11",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11160",
      "OFFICE": "HarHM",
      "START": "1634-03-15",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11160",
      "OFFICE": "K",
      "START": "1623",
      "END": "1637-09-30"
  },
  {
      "COURT": "F3",
      "ID": "11160",
      "OFFICE": "TraHM",
      "START": "1633-01-01",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11164",
      "OFFICE": "RHR",
      "START": "1641-05-10",
      "END": "1653-02-28"
  },
  {
      "COURT": "F3",
      "ID": "11168",
      "OFFICE": "GR",
      "START": "1654-08-16",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11170",
      "OFFICE": "K",
      "START": "1654-10-01",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11171",
      "OFFICE": "K",
      "START": "1653-06-09",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11172",
      "OFFICE": "K",
      "START": "1653-06-10",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11173",
      "OFFICE": "HKaR",
      "START": "1637-04-02",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11175",
      "OFFICE": "RHR",
      "START": "1637-04-15",
      "END": "1649-01-31"
  },
  {
      "COURT": "F3",
      "ID": "11176",
      "OFFICE": "RHR",
      "START": "1641-05-10",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11177",
      "OFFICE": "RHR",
      "START": "1648-12-16",
      "END": "1655-12-15"
  },
  {
      "COURT": "F3",
      "ID": "11178",
      "OFFICE": "RHR",
      "START": "1652-04-08",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11179",
      "OFFICE": "RHR",
      "START": "1656-07-01",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11185",
      "OFFICE": "K",
      "START": "1656-03-08",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11188",
      "OFFICE": "HKrR",
      "START": "1640-06-19",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11188",
      "OFFICE": "HKrSek",
      "START": "1637-04-02",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11190",
      "OFFICE": "HKrR",
      "START": "1643-12-16",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11191",
      "OFFICE": "HKrR",
      "START": "1644-12-01",
      "END": "1649-12-31"
  },
  {
      "COURT": "F3",
      "ID": "11192",
      "OFFICE": "HKrUMM",
      "START": "1637-04-02",
      "END": "1643-12-10"
  },
  {
      "COURT": "F3",
      "ID": "11218",
      "OFFICE": "Ts",
      "START": "1651-09-20",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11303",
      "OFFICE": "Ts",
      "START": "1655-07-28",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11312",
      "OFFICE": "H",
      "START": "1642-01-01",
      "END": "1642-10-16"
  },
  {
      "COURT": "F3",
      "ID": "11312",
      "OFFICE": "HKrSek",
      "START": "1642-10-16",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11312",
      "OFFICE": "R",
      "START": "1642-01-01",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11313",
      "OFFICE": "HKrSek",
      "START": "1637-03-01",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11314",
      "OFFICE": "HKrSek",
      "START": "1637-04-02",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11327",
      "OFFICE": "HKrSek",
      "START": "1637-04-02",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11328",
      "OFFICE": "HKrSek",
      "START": "1638-05-16",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11329",
      "OFFICE": "HKrSek",
      "START": "1640-05-20",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11333",
      "OFFICE": "HKrSek",
      "START": "1642-07-21",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11343",
      "OFFICE": "Ts",
      "START": "1645-08-10",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11348",
      "OFFICE": "R",
      "START": "1654-08-01",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11401",
      "OFFICE": "HKaReg",
      "START": "1638-03-01",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11402",
      "OFFICE": "HKaReg",
      "START": "",
      "END": "1647-08-31"
  },
  {
      "COURT": "F3",
      "ID": "11403",
      "OFFICE": "HKaRegA",
      "START": "1640-04-19",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11413",
      "OFFICE": "HKaKon",
      "START": "1635-06-15",
      "END": "1648-02-01"
  },
  {
      "COURT": "F3",
      "ID": "11414",
      "OFFICE": "HKaKon",
      "START": "1637-04-02",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11419",
      "OFFICE": "HKaSek",
      "START": "1637-04-02",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11503",
      "OFFICE": "Ts",
      "START": "1644-04-05",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11505",
      "OFFICE": "GR",
      "START": "1656-01-14",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11505",
      "OFFICE": "K",
      "START": "1639-04-04",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11524",
      "OFFICE": "Ts",
      "START": "1641-01-18",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "11889",
      "OFFICE": "K",
      "START": "1656-04-06",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "12001",
      "OFFICE": "K0",
      "START": "1649-05-09",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "12001",
      "OFFICE": "RHR",
      "START": "1649-05-02",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "12005",
      "OFFICE": "K",
      "START": "1649-02-11",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "12006",
      "OFFICE": "K",
      "START": "1656-06-13",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "12008",
      "OFFICE": "K",
      "START": "1650-12-28",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "12009",
      "OFFICE": "K",
      "START": "1632",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "12024",
      "OFFICE": "K",
      "START": "1646-12-14",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "12026",
      "OFFICE": "RHR",
      "START": "1656-07-03",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "12029",
      "OFFICE": "Ms",
      "START": "1655-03-23",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "12033",
      "OFFICE": "Fs",
      "START": "1652-11-29",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "12034",
      "OFFICE": "Ts",
      "START": "1653-01-26",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "12038",
      "OFFICE": "K",
      "START": "1649-05-31",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "12055",
      "OFFICE": "K",
      "START": "1632",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "12058",
      "OFFICE": "K",
      "START": "1646-09-05",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "12073",
      "OFFICE": "K",
      "START": "1656-11-19",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "12074",
      "OFFICE": "K",
      "START": "1642-01-02",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "12097",
      "OFFICE": "K",
      "START": "1654-08-08",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "12104",
      "OFFICE": "Ts",
      "START": "1637-05-01",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "12105",
      "OFFICE": "Ts",
      "START": "1637-04-29",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "12106",
      "OFFICE": "Ts",
      "START": "1642-05-01",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "12107",
      "OFFICE": "Ts",
      "START": "1637-10-06",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "12108",
      "OFFICE": "Ts",
      "START": "1642-11-18",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "12123",
      "OFFICE": "Ts",
      "START": "1643-12-01",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "12126",
      "OFFICE": "Ts",
      "START": "1654-01-21",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "12127",
      "OFFICE": "Ts",
      "START": "1653-06-26",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "12128",
      "OFFICE": "K",
      "START": "1651-08-27",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "12134",
      "OFFICE": "K",
      "START": "1625",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "12135",
      "OFFICE": "K",
      "START": "1634",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "12141",
      "OFFICE": "K",
      "START": "1620",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "12142",
      "OFFICE": "K",
      "START": "1655-04-11",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "12146",
      "OFFICE": "K",
      "START": "1652-01-14",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "12147",
      "OFFICE": "K",
      "START": "1625",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "12148",
      "OFFICE": "K",
      "START": "1650-03-25",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "12151",
      "OFFICE": "K",
      "START": "1625",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "12165",
      "OFFICE": "K",
      "START": "1632",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "12167",
      "OFFICE": "K",
      "START": "1625",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "12178",
      "OFFICE": "K",
      "START": "1655-03-30",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "12184",
      "OFFICE": "K",
      "START": "1625",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "12189",
      "OFFICE": "K",
      "START": "1629",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "12201",
      "OFFICE": "K",
      "START": "1652-11-25",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "12202",
      "OFFICE": "K",
      "START": "1649-02-10",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "12204",
      "OFFICE": "K",
      "START": "1656-09-21",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "12423",
      "OFFICE": "K",
      "START": "1653-07-17",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "12502",
      "OFFICE": "K",
      "START": "1636",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "12526",
      "OFFICE": "K",
      "START": "1621",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "12549",
      "OFFICE": "K",
      "START": "1657-01-31",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "12555",
      "OFFICE": "K",
      "START": "1656-09-23",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "12576",
      "OFFICE": "HKaR",
      "START": "1637-04-02",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "12601",
      "OFFICE": "K",
      "START": "1655-03-21",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "13028",
      "OFFICE": "K",
      "START": "1622",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "13029",
      "OFFICE": "K",
      "START": "1646-08-04",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "13034",
      "OFFICE": "Ts",
      "START": "1642-04-08",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "13037",
      "OFFICE": "K",
      "START": "1632-04-19",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "13055",
      "OFFICE": "H",
      "START": "1641-03-17",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "13055",
      "OFFICE": "R",
      "START": "1641-03-17",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "13063",
      "OFFICE": "Ts",
      "START": "1636-04-15",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "13071",
      "OFFICE": "K",
      "START": "1646-08-19",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "13072",
      "OFFICE": "K",
      "START": "1654-08-22",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "13077",
      "OFFICE": "Ts",
      "START": "1647-02-22",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "13078",
      "OFFICE": "K",
      "START": "1654-07-29",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "13098",
      "OFFICE": "HKaR",
      "START": "1637-04-02",
      "END": "1644-09-01"
  },
  {
      "COURT": "F3",
      "ID": "13101",
      "OFFICE": "Ts",
      "START": "1635-07-15",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "13107",
      "OFFICE": "Ts",
      "START": "1637-03-20",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "13123",
      "OFFICE": "HKaR",
      "START": "1655-05-13",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "13123",
      "OFFICE": "K",
      "START": "1654-08-31",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "13150",
      "OFFICE": "K",
      "START": "1615",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "13247",
      "OFFICE": "K",
      "START": "1638-11-11",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "13253",
      "OFFICE": "K",
      "START": "1650-03-06",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "13255",
      "OFFICE": "K",
      "START": "1653-05-13",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "13256",
      "OFFICE": "Ts",
      "START": "1651-12-24",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "13257",
      "OFFICE": "K",
      "START": "1654-11-11",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "13258",
      "OFFICE": "HKrR",
      "START": "1644-03-26",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "14036",
      "OFFICE": "HKrQM",
      "START": "1635-04-20",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "14041",
      "OFFICE": "K",
      "START": "1653-02-15",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "14046",
      "OFFICE": "K",
      "START": "1651-06-27",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "14046",
      "OFFICE": "RHR",
      "START": "1653-01-08",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "14047",
      "OFFICE": "K",
      "START": "1655-02-28",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "14049",
      "OFFICE": "HKaR",
      "START": "1655-03-22",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "14049",
      "OFFICE": "SM",
      "START": "1640-05-01",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "14053",
      "OFFICE": "HKaR",
      "START": "1643-11-19",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "14061",
      "OFFICE": "K",
      "START": "1654-07-31",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "14076",
      "OFFICE": "K",
      "START": "1650-02-16",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "14080",
      "OFFICE": "RHR",
      "START": "1637-04-15",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "14082",
      "OFFICE": "K",
      "START": "1653-03-24",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "14092",
      "OFFICE": "K",
      "START": "1652-05-13",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "14092",
      "OFFICE": "Ts",
      "START": "1647-03-02",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "14094",
      "OFFICE": "Ts",
      "START": "1638-12-29",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "14095",
      "OFFICE": "Ms",
      "START": "1637-07-30",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "14095",
      "OFFICE": "Ts",
      "START": "1636-05-01",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "14097",
      "OFFICE": "Ts",
      "START": "1653-06-15",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "14098",
      "OFFICE": "RHR",
      "START": "1655-06-07",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "14099",
      "OFFICE": "Ts",
      "START": "1655-12-11",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "14102",
      "OFFICE": "K",
      "START": "1648-11-12",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "14685",
      "OFFICE": "K",
      "START": "1650-02-16",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "14893",
      "OFFICE": "Ts",
      "START": "1656-03-15",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "15476",
      "OFFICE": "Ts",
      "START": "1643-06-16",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "15676",
      "OFFICE": "Ts",
      "START": "1657-02-13",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "17243",
      "OFFICE": "Ts",
      "START": "1637-04-29",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "17619",
      "OFFICE": "Ts",
      "START": "1644-03-01",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "17938",
      "OFFICE": "R",
      "START": "1637-07-15",
      "END": "1637-10-16"
  },
  {
      "COURT": "F3",
      "ID": "19182",
      "OFFICE": "Ts",
      "START": "1648-12-25",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "19248",
      "OFFICE": "Ts",
      "START": "1656-01-04",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "19449",
      "OFFICE": "Ts",
      "START": "1639-01-04",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "19508",
      "OFFICE": "GR",
      "START": "1654-08-13",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "19579",
      "OFFICE": "Ms",
      "START": "1653-07-09",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "19840",
      "OFFICE": "K",
      "START": "1650-02-18",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "19840",
      "OFFICE": "Ms",
      "START": "1643-12-03",
      "END": "1650-02-18"
  },
  {
      "COURT": "F3",
      "ID": "19840",
      "OFFICE": "Ts",
      "START": "1641-03-18",
      "END": "1643-12-03"
  },
  {
      "COURT": "F3",
      "ID": "19849",
      "OFFICE": "Kd",
      "START": "1635-12-01",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "20692",
      "OFFICE": "Fs",
      "START": "1649-07-15",
      "END": "1650-03-15"
  },
  {
      "COURT": "F3",
      "ID": "20692",
      "OFFICE": "K",
      "START": "1654-08-19",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "20692",
      "OFFICE": "Ms",
      "START": "1650-03-15",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "31025",
      "OFFICE": "RHR",
      "START": "1646-05-16",
      "END": "1652-04-21"
  },
  {
      "COURT": "F3",
      "ID": "31059",
      "OFFICE": "RHR",
      "START": "1637-04-15",
      "END": "1645-06-10"
  },
  {
      "COURT": "F3",
      "ID": "31063",
      "OFFICE": "RHR",
      "START": "1639-11-01",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "31069",
      "OFFICE": "GR",
      "START": "1652-12-23",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "31080",
      "OFFICE": "RHR",
      "START": "1637-04-15",
      "END": "1649-01-31"
  },
  {
      "COURT": "F3",
      "ID": "31101",
      "OFFICE": "HKaR",
      "START": "1653-05-13",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "31101",
      "OFFICE": "HKaSek",
      "START": "1640-04-01",
      "END": "1654-03-01"
  },
  {
      "COURT": "F3",
      "ID": "31103",
      "OFFICE": "HKaKon",
      "START": "",
      "END": "1645-11-12"
  },
  {
      "COURT": "F3",
      "ID": "31104",
      "OFFICE": "HKaKon",
      "START": "1637-04-02",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "31106",
      "OFFICE": "HKaKon",
      "START": "1652-01-01",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "31107",
      "OFFICE": "HKaKon",
      "START": "1641-04-22",
      "END": "1645-08-16"
  },
  {
      "COURT": "F3",
      "ID": "31108",
      "OFFICE": "HKaKon",
      "START": "1637-08-01",
      "END": "1654-11-19"
  },
  {
      "COURT": "F3",
      "ID": "31108",
      "OFFICE": "HKaSek",
      "START": "1654-11-19",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "31109",
      "OFFICE": "HKaR",
      "START": "1653-05-03",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "31111",
      "OFFICE": "HKrOMM",
      "START": "1637-04-01",
      "END": "1639-09-01"
  },
  {
      "COURT": "F3",
      "ID": "31112",
      "OFFICE": "HKaKon",
      "START": "1637-04-02",
      "END": "1651-05-27"
  },
  {
      "COURT": "F3",
      "ID": "31112",
      "OFFICE": "HKaSek",
      "START": "1651-05-27",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "31114",
      "OFFICE": "HKaKon",
      "START": "1637-04-02",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "31125",
      "OFFICE": "RHR",
      "START": "1637-04-15",
      "END": "1650-07-16"
  },
  {
      "COURT": "F3",
      "ID": "31152",
      "OFFICE": "HKaKon",
      "START": "1642-02-01",
      "END": "1654-11-18"
  },
  {
      "COURT": "F3",
      "ID": "31152",
      "OFFICE": "HKaSek",
      "START": "1654-11-18",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "31163",
      "OFFICE": "HZM",
      "START": "1639-02-11",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "31165",
      "OFFICE": "HKaR",
      "START": "1648-04-17",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "31167",
      "OFFICE": "HKaKon",
      "START": "1648-03-01",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "31571",
      "OFFICE": "Ts",
      "START": "1643-05-06",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "31578",
      "OFFICE": "Med",
      "START": "",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "31580",
      "OFFICE": "Med",
      "START": "",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "31581",
      "OFFICE": "Med",
      "START": "",
      "END": ""
  },
  {
      "COURT": "F3",
      "ID": "31582",
      "OFFICE": "Med",
      "START": "",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10011",
      "OFFICE": "GR",
      "START": "1657-07-01",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10020",
      "OFFICE": "GR",
      "START": "1678-11-02",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10020",
      "OFFICE": "K",
      "START": "1657-07-18",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10036",
      "OFFICE": "K",
      "START": "1657-07-18",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10045",
      "OFFICE": "GR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10058",
      "OFFICE": "GR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10058",
      "OFFICE": "OHM",
      "START": "1665-03-24",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10063",
      "OFFICE": "K",
      "START": "1658-01-17",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10066",
      "OFFICE": "GR",
      "START": "1679-06-22",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10066",
      "OFFICE": "K",
      "START": "1657-07-18",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10066",
      "OFFICE": "OK",
      "START": "1690-04-26",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10084",
      "OFFICE": "GR",
      "START": "1660-12-04",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10084",
      "OFFICE": "OHM",
      "START": "1675-05-29",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10085",
      "OFFICE": "GR",
      "START": "1667-10-19",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10085",
      "OFFICE": "OHM",
      "START": "",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10091",
      "OFFICE": "GR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10092",
      "OFFICE": "GR",
      "START": "1687-04-22",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10092",
      "OFFICE": "K",
      "START": "1658-09-21",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10095",
      "OFFICE": "GR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10120",
      "OFFICE": "GR",
      "START": "1659-06-25",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10120",
      "OFFICE": "HKaP",
      "START": "1657-06-22",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10129",
      "OFFICE": "GR",
      "START": "1685-12-07",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10147",
      "OFFICE": "GR",
      "START": "1659-06-25",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10158",
      "OFFICE": "GR",
      "START": "1675-12-23",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10159",
      "OFFICE": "GR",
      "START": "1668-08-28",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10160",
      "OFFICE": "K",
      "START": "1657-07-18",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10161",
      "OFFICE": "K",
      "START": "1672-07-13",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10162",
      "OFFICE": "K",
      "START": "1674-09-04",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10164",
      "OFFICE": "GR",
      "START": "1666-02-08",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10164",
      "OFFICE": "OHMar",
      "START": "",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10164",
      "OFFICE": "OJM",
      "START": "",
      "END": "1666-02-08"
  },
  {
      "COURT": "L1",
      "ID": "10165",
      "OFFICE": "GR",
      "START": "1657-06-27",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10166",
      "OFFICE": "GR",
      "START": "1676",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10166",
      "OFFICE": "K",
      "START": "1654-08-21",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10173",
      "OFFICE": "GR",
      "START": "1659-11-15",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10176",
      "OFFICE": "GR",
      "START": "1657-06-27",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10180",
      "OFFICE": "GR",
      "START": "1665-06-26",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10187",
      "OFFICE": "GR",
      "START": "1666-03-22",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10198",
      "OFFICE": "K",
      "START": "1657-07-15",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10199",
      "OFFICE": "GR",
      "START": "1662",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10206",
      "OFFICE": "K",
      "START": "1657-07-18",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10207",
      "OFFICE": "K",
      "START": "1657-07-15",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10208",
      "OFFICE": "K",
      "START": "1658-12-27",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10210",
      "OFFICE": "GR",
      "START": "1687-04-18",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10210",
      "OFFICE": "K",
      "START": "1657-07-18",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10222",
      "OFFICE": "K",
      "START": "1657-07-18",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10223",
      "OFFICE": "GR",
      "START": "1683-09-05",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10223",
      "OFFICE": "K",
      "START": "1658-06-03",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10260",
      "OFFICE": "GR",
      "START": "1662-03-07",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10260",
      "OFFICE": "OK",
      "START": "1675-07-03",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10260",
      "OFFICE": "OStallM",
      "START": "1658-01-10",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10290",
      "OFFICE": "K",
      "START": "1673-02-01",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10310",
      "OFFICE": "K",
      "START": "1657-07-18",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10328",
      "OFFICE": "K",
      "START": "1659-09-12",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10330",
      "OFFICE": "K",
      "START": "1661-08-08",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10356",
      "OFFICE": "GR",
      "START": "1665-09-03",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10359",
      "OFFICE": "K",
      "START": "1656-09-14",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10361",
      "OFFICE": "K",
      "START": "1658-09-21",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10367",
      "OFFICE": "K",
      "START": "1664-05-06",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10378",
      "OFFICE": "GR",
      "START": "1672-09-20",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10379",
      "OFFICE": "GR",
      "START": "1681",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10379",
      "OFFICE": "K",
      "START": "1656-09-14",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10426",
      "OFFICE": "GR",
      "START": "1682-12-01",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10426",
      "OFFICE": "K",
      "START": "1657-07-18",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10433",
      "OFFICE": "K",
      "START": "1660-03-11",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10435",
      "OFFICE": "K",
      "START": "1670-04-13",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10438",
      "OFFICE": "GR",
      "START": "1697-10-02",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10438",
      "OFFICE": "K",
      "START": "1682",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10439",
      "OFFICE": "K",
      "START": "1686-06-15",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10462",
      "OFFICE": "K",
      "START": "1657-07-18",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10491",
      "OFFICE": "GR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10493",
      "OFFICE": "GR",
      "START": "1672-09-18",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10508",
      "OFFICE": "K",
      "START": "1657-07-18",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10513",
      "OFFICE": "K",
      "START": "1657-07-18",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10533",
      "OFFICE": "K",
      "START": "1657-07-18",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10536",
      "OFFICE": "K",
      "START": "1662-05-28",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10552",
      "OFFICE": "K",
      "START": "1657-07-18",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10555",
      "OFFICE": "GR",
      "START": "1665-09-02",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10556",
      "OFFICE": "K",
      "START": "1678-02-11",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10584",
      "OFFICE": "K",
      "START": "1673-09-17",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10605",
      "OFFICE": "K",
      "START": "1657-07-18",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10607",
      "OFFICE": "GR",
      "START": "1681-04-14",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10607",
      "OFFICE": "K",
      "START": "1654-08-03",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10608",
      "OFFICE": "K",
      "START": "1684-05-24",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10609",
      "OFFICE": "GR",
      "START": "1671-02-23",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10609",
      "OFFICE": "HVC",
      "START": "1665-12-24",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10615",
      "OFFICE": "K",
      "START": "1665-01-06",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10616",
      "OFFICE": "K",
      "START": "1676-12-14",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10633",
      "OFFICE": "K",
      "START": "1657-07-18",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10638",
      "OFFICE": "K",
      "START": "1658-12-24",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10643",
      "OFFICE": "K",
      "START": "1657-07-18",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10649",
      "OFFICE": "GR",
      "START": "1687-04-28",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10649",
      "OFFICE": "K",
      "START": "1660-02-26",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10659",
      "OFFICE": "K",
      "START": "1657-07-18",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10672",
      "OFFICE": "K",
      "START": "1660-08-17",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10675",
      "OFFICE": "GR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10676",
      "OFFICE": "K",
      "START": "1654-08-03",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10679",
      "OFFICE": "GR",
      "START": "1683-11-13",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10679",
      "OFFICE": "K",
      "START": "1657-07-18",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10694",
      "OFFICE": "K",
      "START": "1654-08-22",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10699",
      "OFFICE": "GR",
      "START": "1681-04-18",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10699",
      "OFFICE": "K",
      "START": "1657-07-18",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10715",
      "OFFICE": "K",
      "START": "1663-01-24",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10722",
      "OFFICE": "GR",
      "START": "1659-11-28",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10751",
      "OFFICE": "K",
      "START": "1657-07-18",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10769",
      "OFFICE": "K",
      "START": "1664-05-06",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10779",
      "OFFICE": "K",
      "START": "1657-07-18",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10780",
      "OFFICE": "K",
      "START": "1660-10-02",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10781",
      "OFFICE": "K",
      "START": "1677-12-22",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10803",
      "OFFICE": "K",
      "START": "1657-07-18",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10805",
      "OFFICE": "K",
      "START": "1677-06-09",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10809",
      "OFFICE": "GR",
      "START": "1671-02-26",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10809",
      "OFFICE": "HVC",
      "START": "",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10809",
      "OFFICE": "K",
      "START": "1680-11-03",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10821",
      "OFFICE": "K",
      "START": "1674-04-03",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10829",
      "OFFICE": "GR",
      "START": "1681-04-25",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10829",
      "OFFICE": "K",
      "START": "1658-01-17",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10832",
      "OFFICE": "K",
      "START": "1657-07-18",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10842",
      "OFFICE": "K",
      "START": "1665-04-19",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10852",
      "OFFICE": "K",
      "START": "1665-04-19",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10854",
      "OFFICE": "GR",
      "START": "1685-07-20",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10854",
      "OFFICE": "K",
      "START": "1662-10-30",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10865",
      "OFFICE": "K",
      "START": "1660-09-28",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10888",
      "OFFICE": "GR",
      "START": "1660",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10898",
      "OFFICE": "GR",
      "START": "1681-08-02",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10898",
      "OFFICE": "K",
      "START": "1657-07-18",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10961",
      "OFFICE": "K",
      "START": "1673-09-09",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10966",
      "OFFICE": "K",
      "START": "1675-11-16",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10969",
      "OFFICE": "K",
      "START": "1670-04-13",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10977",
      "OFFICE": "GR",
      "START": "1678-02-13",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10977",
      "OFFICE": "K",
      "START": "1654-08-20",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10981",
      "OFFICE": "K",
      "START": "1657-07-15",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10988",
      "OFFICE": "K",
      "START": "1657-07-18",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "10993",
      "OFFICE": "K",
      "START": "1679-11-15",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "11008",
      "OFFICE": "K",
      "START": "1655-03-19",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "11048",
      "OFFICE": "K",
      "START": "1657-07-18",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "11049",
      "OFFICE": "K",
      "START": "1666-12-30",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "11056",
      "OFFICE": "K",
      "START": "1669-03-26",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "11065",
      "OFFICE": "K",
      "START": "1669-12-07",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "11068",
      "OFFICE": "GR",
      "START": "1679-06-20",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "11068",
      "OFFICE": "K",
      "START": "1656-06-25",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "11079",
      "OFFICE": "K",
      "START": "1673-09-12",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "11111",
      "OFFICE": "K",
      "START": "1679-06-09",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "11128",
      "OFFICE": "K",
      "START": "1664-06-25",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "11129",
      "OFFICE": "K",
      "START": "1661-07-06",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "11133",
      "OFFICE": "K",
      "START": "1664-06-23",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "11140",
      "OFFICE": "K",
      "START": "1670-06-09",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "11144",
      "OFFICE": "K",
      "START": "1677-10-31",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "11155",
      "OFFICE": "K",
      "START": "1659-11-25",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "11158",
      "OFFICE": "K",
      "START": "1666-02-08",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "11172",
      "OFFICE": "K",
      "START": "1664-04-13",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "11194",
      "OFFICE": "K",
      "START": "1673-09-09",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "11216",
      "OFFICE": "K",
      "START": "1662-05-28",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "11243",
      "OFFICE": "K",
      "START": "1658-02-10",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "11249",
      "OFFICE": "K",
      "START": "1673-09-02",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "11368",
      "OFFICE": "GR",
      "START": "1687-05-23",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "11519",
      "OFFICE": "K",
      "START": "1683-08-22",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "11554",
      "OFFICE": "GR",
      "START": "1705-03-21",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "11623",
      "OFFICE": "GR",
      "START": "1685-02-03",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "11623",
      "OFFICE": "K",
      "START": "1655-02-08",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "11628",
      "OFFICE": "K",
      "START": "1668-07-12",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "11713",
      "OFFICE": "K",
      "START": "1676-01-18",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "11716",
      "OFFICE": "K",
      "START": "1684-02-29",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "11719",
      "OFFICE": "K",
      "START": "1679-06-09",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "11782",
      "OFFICE": "K",
      "START": "1660-02-02",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "11783",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "11784",
      "OFFICE": "K",
      "START": "1670-01-25",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "11798",
      "OFFICE": "K",
      "START": "1666-02-04",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "11799",
      "OFFICE": "K",
      "START": "1678-01-06",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "11888",
      "OFFICE": "GR",
      "START": "1672-09-01",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "11966",
      "OFFICE": "K",
      "START": "1668-01-09",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "12006",
      "OFFICE": "GR",
      "START": "1689-05-25",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "12006",
      "OFFICE": "K",
      "START": "1662-08-28",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "12026",
      "OFFICE": "GR",
      "START": "1683-02-06",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "12033",
      "OFFICE": "K",
      "START": "1659-11-17",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "12054",
      "OFFICE": "GR",
      "START": "1681-12-29",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "12054",
      "OFFICE": "K",
      "START": "1655-03-19",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "12058",
      "OFFICE": "K",
      "START": "1659-02-28",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "12071",
      "OFFICE": "K",
      "START": "1665-05-19",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "12073",
      "OFFICE": "K",
      "START": "1657-07-18",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "12076",
      "OFFICE": "K",
      "START": "1655-04-10",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "12087",
      "OFFICE": "K",
      "START": "1656-08-14",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "12089",
      "OFFICE": "K",
      "START": "1680-09-17",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "12102",
      "OFFICE": "K",
      "START": "1663-11-28",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "12103",
      "OFFICE": "K",
      "START": "1670-06-09",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "12107",
      "OFFICE": "K",
      "START": "1677-06-09",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "12126",
      "OFFICE": "K",
      "START": "1664-06-25",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "12131",
      "OFFICE": "K",
      "START": "1672-04-22",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "12132",
      "OFFICE": "K",
      "START": "1664-07-19",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "12185",
      "OFFICE": "K",
      "START": "1677-06-09",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "12204",
      "OFFICE": "K",
      "START": "1657-07-18",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "12279",
      "OFFICE": "K",
      "START": "1666-12-30",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "12335",
      "OFFICE": "GR",
      "START": "1672-03-29",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "12407",
      "OFFICE": "GR",
      "START": "1686-04-03",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "12416",
      "OFFICE": "K",
      "START": "1672-10-29",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "12419",
      "OFFICE": "K",
      "START": "1678-01-06",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "12429",
      "OFFICE": "K",
      "START": "1660-02-26",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "12430",
      "OFFICE": "K",
      "START": "1665-09-09",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "12524",
      "OFFICE": "GR",
      "START": "1682-11-23",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "12524",
      "OFFICE": "K",
      "START": "1665-08-21",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "12548",
      "OFFICE": "K",
      "START": "1683-11-04",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "12549",
      "OFFICE": "K",
      "START": "1659-01-06",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "12555",
      "OFFICE": "K",
      "START": "1657-07-18",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "12569",
      "OFFICE": "K",
      "START": "1680-10-21",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "12577",
      "OFFICE": "K",
      "START": "1655-08-21",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "12579",
      "OFFICE": "K",
      "START": "1661-09-18",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "12587",
      "OFFICE": "GR",
      "START": "1684",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "12587",
      "OFFICE": "K",
      "START": "1654-08-03",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "12633",
      "OFFICE": "K",
      "START": "1664-12-19",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "12642",
      "OFFICE": "K",
      "START": "1660-05-12",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "12658",
      "OFFICE": "K",
      "START": "1670-01-25",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "12665",
      "OFFICE": "K",
      "START": "1670-06-09",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "12699",
      "OFFICE": "K",
      "START": "1666-12-22",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "12704",
      "OFFICE": "K",
      "START": "1661-10-13",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "12769",
      "OFFICE": "K",
      "START": "1679-06-09",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "12797",
      "OFFICE": "K",
      "START": "1664-05-07",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "12820",
      "OFFICE": "GR",
      "START": "1683-12-18",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "12820",
      "OFFICE": "K",
      "START": "1668-03-01",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "12820",
      "OFFICE": "OHMar",
      "START": "",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "12871",
      "OFFICE": "K",
      "START": "1658-06-01",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "12872",
      "OFFICE": "K",
      "START": "1663-01-15",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "12904",
      "OFFICE": "K",
      "START": "1655-07-05",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "12935",
      "OFFICE": "K",
      "START": "1655-03-19",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "12962",
      "OFFICE": "K",
      "START": "1668-01-05",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "12977",
      "OFFICE": "K",
      "START": "1665-05-22",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "13072",
      "OFFICE": "K",
      "START": "1657-07-15",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "13077",
      "OFFICE": "K",
      "START": "1664-11-24",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "13156",
      "OFFICE": "K",
      "START": "1681-05-12",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "13216",
      "OFFICE": "GR",
      "START": "1688-12-20",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "13216",
      "OFFICE": "K",
      "START": "1663-01-15",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "13217",
      "OFFICE": "K",
      "START": "1671-05-14",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "13218",
      "OFFICE": "K",
      "START": "1672-04-22",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "13231",
      "OFFICE": "GR",
      "START": "1681-07-23",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "13250",
      "OFFICE": "GR",
      "START": "1682-11-27",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "13253",
      "OFFICE": "GR",
      "START": "1674-08-04",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "13253",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "13253",
      "OFFICE": "OHMar",
      "START": "",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "13253",
      "OFFICE": "OHMX",
      "START": "1665-10",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "13255",
      "OFFICE": "K",
      "START": "1657-07-18",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "13257",
      "OFFICE": "GR",
      "START": "1671-05-18",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "13303",
      "OFFICE": "K",
      "START": "1685-06-02",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "13431",
      "OFFICE": "K",
      "START": "1676-12-14",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "13456",
      "OFFICE": "K",
      "START": "1678-06-02",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "13477",
      "OFFICE": "K",
      "START": "1671-06-09",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "13694",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "13734",
      "OFFICE": "K",
      "START": "1670-03-22",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "13748",
      "OFFICE": "K",
      "START": "1663-10-27",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "13749",
      "OFFICE": "K",
      "START": "1665-09-11",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "13750",
      "OFFICE": "K",
      "START": "1673-01-13",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "13758",
      "OFFICE": "K",
      "START": "1677-06-09",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "13790",
      "OFFICE": "K",
      "START": "1673-11-28",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "13860",
      "OFFICE": "K",
      "START": "1666-01-06",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "13870",
      "OFFICE": "K",
      "START": "1673-09-07",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "13871",
      "OFFICE": "K",
      "START": "1678-01-06",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "13892",
      "OFFICE": "GR",
      "START": "1698-08-22",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "13892",
      "OFFICE": "K",
      "START": "1665-01-06",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "14068",
      "OFFICE": "GR",
      "START": "1682-12-04",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "14068",
      "OFFICE": "HarHM",
      "START": "",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "14069",
      "OFFICE": "GR",
      "START": "1689-08-28",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "14069",
      "OFFICE": "K",
      "START": "1664-06-25",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "14083",
      "OFFICE": "K",
      "START": "1664-09-04",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "14089",
      "OFFICE": "K",
      "START": "1675-11-17",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "14090",
      "OFFICE": "K",
      "START": "1681-05-22",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "14104",
      "OFFICE": "K",
      "START": "1676-12-14",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "14120",
      "OFFICE": "GR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "14120",
      "OFFICE": "K",
      "START": "1674-12-06",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "14178",
      "OFFICE": "K",
      "START": "1665-07-25",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "14179",
      "OFFICE": "K",
      "START": "1673-01-13",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "14204",
      "OFFICE": "GR",
      "START": "1683-02-20",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "14205",
      "OFFICE": "GR",
      "START": "1694-12-22",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "14205",
      "OFFICE": "K",
      "START": "1675-11-17",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "14326",
      "OFFICE": "K",
      "START": "1683-06-09",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "14356",
      "OFFICE": "K",
      "START": "1660-10-18",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "14385",
      "OFFICE": "K",
      "START": "1678-01-04",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "14417",
      "OFFICE": "GR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "14450",
      "OFFICE": "K",
      "START": "1669-12-07",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "14453",
      "OFFICE": "GR",
      "START": "1682-11-20",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "14453",
      "OFFICE": "K",
      "START": "1654-07-30",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "14454",
      "OFFICE": "K",
      "START": "1663-01-11",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "14532",
      "OFFICE": "K",
      "START": "1666-09-06",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "14544",
      "OFFICE": "K",
      "START": "1680-01-31",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "14580",
      "OFFICE": "K",
      "START": "1678-01-06",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "14620",
      "OFFICE": "K",
      "START": "1677-01-08",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "14622",
      "OFFICE": "GR",
      "START": "1692-01-08",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "14622",
      "OFFICE": "K",
      "START": "1672-05-03",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "14630",
      "OFFICE": "GR",
      "START": "1676-01-14",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "14660",
      "OFFICE": "K",
      "START": "1671-02-01",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "14686",
      "OFFICE": "K",
      "START": "1674-04-03",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "14699",
      "OFFICE": "GR",
      "START": "1696-10-16",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "14699",
      "OFFICE": "K",
      "START": "1674-12-31",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "14705",
      "OFFICE": "K",
      "START": "1671-08-15",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "14721",
      "OFFICE": "K",
      "START": "1672-11-21",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "14999",
      "OFFICE": "K",
      "START": "1679-11-15",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "15066",
      "OFFICE": "K",
      "START": "1658-05-01",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "15085",
      "OFFICE": "K",
      "START": "1681-01-23",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "15458",
      "OFFICE": "GR",
      "START": "1698-12-30",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "15458",
      "OFFICE": "K",
      "START": "1680-10-26",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "15459",
      "OFFICE": "K",
      "START": "1685-04-02",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "15473",
      "OFFICE": "K",
      "START": "1679-06-03",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "15590",
      "OFFICE": "GR",
      "START": "1675-05-13",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "15595",
      "OFFICE": "GR",
      "START": "1697-09-25",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "15595",
      "OFFICE": "K",
      "START": "1664-09-30",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "15646",
      "OFFICE": "HC",
      "START": "1694-02-16",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "15646",
      "OFFICE": "HVC",
      "START": "1682-08-25",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "15670",
      "OFFICE": "GR",
      "START": "1682-05-02",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "15676",
      "OFFICE": "K",
      "START": "1674-04-21",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "15682",
      "OFFICE": "GR",
      "START": "1673-10-18",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "15824",
      "OFFICE": "GR",
      "START": "1685-09-03",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "15972",
      "OFFICE": "K",
      "START": "1685-10-02",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "16030",
      "OFFICE": "GR",
      "START": "1699-07-11",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "16030",
      "OFFICE": "K",
      "START": "1670-04-19",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "16377",
      "OFFICE": "K",
      "START": "1672-09-26",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "16379",
      "OFFICE": "K",
      "START": "1665-09-24",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "16392",
      "OFFICE": "GR",
      "START": "1702-04-07",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "16470",
      "OFFICE": "GR",
      "START": "1665-09-07",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "16471",
      "OFFICE": "K",
      "START": "1666-12-30",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "16472",
      "OFFICE": "K",
      "START": "1670-01-25",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "16491",
      "OFFICE": "K",
      "START": "1685-08-18",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "16496",
      "OFFICE": "K",
      "START": "1678-02-23",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "16527",
      "OFFICE": "K",
      "START": "1671-05-14",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "16537",
      "OFFICE": "GR",
      "START": "1662-03-08",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "16537",
      "OFFICE": "HVC",
      "START": "",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "16728",
      "OFFICE": "K",
      "START": "1678-02-22",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "16864",
      "OFFICE": "K",
      "START": "1680-03-20",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "16866",
      "OFFICE": "GR",
      "START": "1682-11-19",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "16866",
      "OFFICE": "K",
      "START": "1651-04-01",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "16866",
      "OFFICE": "OJM",
      "START": "",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "16947",
      "OFFICE": "K",
      "START": "1685-09-22",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "17071",
      "OFFICE": "GR",
      "START": "1687-04-26",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "17071",
      "OFFICE": "K",
      "START": "1662-10-30",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "17223",
      "OFFICE": "K",
      "START": "1656-02-20",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "17239",
      "OFFICE": "K",
      "START": "1665-10-24",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "17241",
      "OFFICE": "K",
      "START": "1659-08-04",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "17401",
      "OFFICE": "K",
      "START": "1678-06-02",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "17402",
      "OFFICE": "K",
      "START": "1679-06-09",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "17459",
      "OFFICE": "K",
      "START": "1674-04-05",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "17460",
      "OFFICE": "K",
      "START": "1672-04-22",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "17604",
      "OFFICE": "K",
      "START": "1671-02-01",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "17837",
      "OFFICE": "K",
      "START": "1662-08-19",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "17998",
      "OFFICE": "K",
      "START": "1669-03-26",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "18660",
      "OFFICE": "K",
      "START": "1664-06-24",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "18780",
      "OFFICE": "GR",
      "START": "1703-03-28",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "18990",
      "OFFICE": "K",
      "START": "1670-03-22",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "19090",
      "OFFICE": "GR",
      "START": "1673-10-14",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "19090",
      "OFFICE": "K",
      "START": "1658-01-17",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "19090",
      "OFFICE": "OStallM",
      "START": "1677-11-22",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "19099",
      "OFFICE": "K",
      "START": "1668-01-05",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "19127",
      "OFFICE": "K",
      "START": "1669-12-07",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "19128",
      "OFFICE": "K",
      "START": "1673-10-20",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "19182",
      "OFFICE": "K",
      "START": "1677-06-09",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "19207",
      "OFFICE": "K",
      "START": "1679-01-06",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "19208",
      "OFFICE": "K",
      "START": "1658-01-17",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "19210",
      "OFFICE": "K",
      "START": "1661-06-22",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "19240",
      "OFFICE": "GR",
      "START": "1685-10-19",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "19249",
      "OFFICE": "GR",
      "START": "1695-05-13",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "19249",
      "OFFICE": "K",
      "START": "1671-04-04",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "19268",
      "OFFICE": "K",
      "START": "1669-05-04",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "19269",
      "OFFICE": "K",
      "START": "1674-04-03",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "19270",
      "OFFICE": "K",
      "START": "1656-09-14",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "19271",
      "OFFICE": "K",
      "START": "1673-09-08",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "19276",
      "OFFICE": "GR",
      "START": "1701-11-09",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "19277",
      "OFFICE": "K",
      "START": "1665-04-18",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "19278",
      "OFFICE": "GR",
      "START": "1703-10-13",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "19280",
      "OFFICE": "GR",
      "START": "1687-09-07",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "19284",
      "OFFICE": "K",
      "START": "1670-01-25",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "19287",
      "OFFICE": "K",
      "START": "1658-12-10",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "19288",
      "OFFICE": "K",
      "START": "1676-12-14",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "19356",
      "OFFICE": "GR",
      "START": "1695-05-17",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "19419",
      "OFFICE": "GR",
      "START": "1700-05-07",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "19419",
      "OFFICE": "K",
      "START": "1683-12-12",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "19486",
      "OFFICE": "GR",
      "START": "1700-11-29",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "19488",
      "OFFICE": "GR",
      "START": "1694-03-10",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "19488",
      "OFFICE": "K",
      "START": "1677-08-13",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "19559",
      "OFFICE": "GR",
      "START": "1693-07-10",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "19559",
      "OFFICE": "K",
      "START": "1673-10-24",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "19560",
      "OFFICE": "GR",
      "START": "1687-10-23",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "19560",
      "OFFICE": "K",
      "START": "1660-02-26",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "19580",
      "OFFICE": "GR",
      "START": "1687-04-25",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "19580",
      "OFFICE": "K",
      "START": "1662-03-26",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "19582",
      "OFFICE": "GR",
      "START": "1687-04-03",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "19582",
      "OFFICE": "K",
      "START": "1681-07-11",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "19608",
      "OFFICE": "K",
      "START": "1673-10-15",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "19609",
      "OFFICE": "GR",
      "START": "1680",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "19613",
      "OFFICE": "K",
      "START": "1680-10-29",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "19629",
      "OFFICE": "K",
      "START": "1681-01-06",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "19684",
      "OFFICE": "GR",
      "START": "1697-04-18",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "19742",
      "OFFICE": "GR",
      "START": "1699-02-19",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "19742",
      "OFFICE": "K",
      "START": "1683-06-09",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "19829",
      "OFFICE": "GR",
      "START": "1701-04-06",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "19829",
      "OFFICE": "K",
      "START": "1677-03-30",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "19840",
      "OFFICE": "K",
      "START": "1657-07-18",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "19841",
      "OFFICE": "K",
      "START": "1656-09-16",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "19842",
      "OFFICE": "K",
      "START": "1678-06-09",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "19843",
      "OFFICE": "K",
      "START": "1678-06-09",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "19845",
      "OFFICE": "GR",
      "START": "1700-08-14",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "19850",
      "OFFICE": "GR",
      "START": "1693-04-10",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "19850",
      "OFFICE": "K",
      "START": "1666-12-30",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "19856",
      "OFFICE": "K",
      "START": "1685-06-16",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "19860",
      "OFFICE": "GR",
      "START": "1683-12-23",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "19860",
      "OFFICE": "HC",
      "START": "1683-06-28",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "19861",
      "OFFICE": "GR",
      "START": "1704-08-14",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "20692",
      "OFFICE": "K",
      "START": "1657-07-18",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "20693",
      "OFFICE": "K",
      "START": "1673-09-26",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "20698",
      "OFFICE": "K",
      "START": "1685-09-21",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "20950",
      "OFFICE": "K",
      "START": "1675-07-15",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "20951",
      "OFFICE": "K",
      "START": "1679-01-25",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "21006",
      "OFFICE": "GR",
      "START": "1703-10-31",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "21006",
      "OFFICE": "K",
      "START": "1680-06-11",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "21022",
      "OFFICE": "GR",
      "START": "1697-12-20",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "21022",
      "OFFICE": "K",
      "START": "1683-06-09",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "21023",
      "OFFICE": "K",
      "START": "1673-10-30",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "21993",
      "OFFICE": "K",
      "START": "1682",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "24640",
      "OFFICE": "K",
      "START": "1673-08-23",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "24641",
      "OFFICE": "GR",
      "START": "1700-08-13",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "24641",
      "OFFICE": "K",
      "START": "1681-07-12",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "31069",
      "OFFICE": "GR",
      "START": "1658-03-26",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "31122",
      "OFFICE": "HKaR",
      "START": "1665-12-24",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "31202",
      "OFFICE": "GR",
      "START": "1681-07-24",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "31202",
      "OFFICE": "HKaP",
      "START": "1681-03-18",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "31202",
      "OFFICE": "HKaPX",
      "START": "1680-04-13",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "31320",
      "OFFICE": "GR",
      "START": "1669-08-25",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "31320",
      "OFFICE": "HC",
      "START": "1667-03-07",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "31320",
      "OFFICE": "HVC",
      "START": "1665-10-18",
      "END": ""
  },
  {
      "COURT": "L1",
      "ID": "31574",
      "OFFICE": "K",
      "START": "1685-09-10",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "10087",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "10087",
      "OFFICE": "OStallM",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "10098",
      "OFFICE": "Fs",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "10118",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "10118",
      "OFFICE": "Ts",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "10150",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "10150",
      "OFFICE": "Ms",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "10251",
      "OFFICE": "H0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "10251",
      "OFFICE": "H1",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "10264",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "10264",
      "OFFICE": "K0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "10264",
      "OFFICE": "OK",
      "START": "1573-11-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "10352",
      "OFFICE": "RHR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "10422",
      "OFFICE": "H2",
      "START": "1565-12-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "10422",
      "OFFICE": "Ts",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "10445",
      "OFFICE": "RHR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "10642",
      "OFFICE": "HKrR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "10759",
      "OFFICE": "HKaR",
      "START": "1575-03-31",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "10784",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "10875",
      "OFFICE": "HKrR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "10876",
      "OFFICE": "RHR",
      "START": "1576-05-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "11016",
      "OFFICE": "RHR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "11060",
      "OFFICE": "Fs",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "11085",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "11086",
      "OFFICE": "H2",
      "START": "1572-12-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "11086",
      "OFFICE": "Ts",
      "START": "1575-01-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "11094",
      "OFFICE": "HCSekLA",
      "START": "",
      "END": "1569-05-01"
  },
  {
      "COURT": "M2",
      "ID": "11095",
      "OFFICE": "HZM",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "11107",
      "OFFICE": "RHR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "11150",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "11174",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "11174",
      "OFFICE": "H3",
      "START": "1573-04-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "11203",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "11235",
      "OFFICE": "Fs",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "11235",
      "OFFICE": "Pt",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "11235",
      "OFFICE": "Ts",
      "START": "1566-01-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "11253",
      "OFFICE": "H0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "11253",
      "OFFICE": "Ts",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "11260",
      "OFFICE": "H",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "11260",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "11260",
      "OFFICE": "K0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "11283",
      "OFFICE": "H",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "11297",
      "OFFICE": "Fs",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "11298",
      "OFFICE": "HKrR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "11311",
      "OFFICE": "HKaP",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "11311",
      "OFFICE": "RHR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "11352",
      "OFFICE": "OTs",
      "START": "1571-08-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "11352",
      "OFFICE": "RHR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "11356",
      "OFFICE": "RHSek",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "11428",
      "OFFICE": "Fs",
      "START": "1576-01-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "11473",
      "OFFICE": "H3",
      "START": "1566-03-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "11516",
      "OFFICE": "RHR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "11534",
      "OFFICE": "Ts",
      "START": "1573-10-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "11546",
      "OFFICE": "HCSekLA",
      "START": "1572-04-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "11547",
      "OFFICE": "HKaSek",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "11580",
      "OFFICE": "H",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "11580",
      "OFFICE": "Ts",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "11588",
      "OFFICE": "H0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "11588",
      "OFFICE": "H3",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "11588",
      "OFFICE": "Ms",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "11614",
      "OFFICE": "HZM",
      "START": "1572-03-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "11642",
      "OFFICE": "H2",
      "START": "1575-05-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "11644",
      "OFFICE": "RHR",
      "START": "1573-04-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "11648",
      "OFFICE": "RHR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "11651",
      "OFFICE": "Med",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "11652",
      "OFFICE": "RHR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "11656",
      "OFFICE": "RHR",
      "START": "1571-11-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "11674",
      "OFFICE": "H0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "11674",
      "OFFICE": "Ms",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "11681",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "11701",
      "OFFICE": "RHR",
      "START": "1576-04-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "11711",
      "OFFICE": "HKaR",
      "START": "1575-02-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "11723",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "11723",
      "OFFICE": "Ts",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "11726",
      "OFFICE": "H1",
      "START": "1573-08-31",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "11726",
      "OFFICE": "H2",
      "START": "1575-01-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "11726",
      "OFFICE": "Ts",
      "START": "1575-09-22",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "11740",
      "OFFICE": "H2",
      "START": "1575-08-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "11818",
      "OFFICE": "H0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "11818",
      "OFFICE": "Pt",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "11819",
      "OFFICE": "HKrR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "11852",
      "OFFICE": "H1",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "11868",
      "OFFICE": "Ts",
      "START": "1574-09-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "11895",
      "OFFICE": "R",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "11945",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "11945",
      "OFFICE": "K0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "11986",
      "OFFICE": "Ts",
      "START": "1572-06-14",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "11993",
      "OFFICE": "HKaD",
      "START": "1570-07-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "12082",
      "OFFICE": "Fs",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "12082",
      "OFFICE": "H0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "12082",
      "OFFICE": "Pt",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "12082",
      "OFFICE": "Ts",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "12096",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "12096",
      "OFFICE": "Ts",
      "START": "1566-12-15",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "12149",
      "OFFICE": "H2",
      "START": "1575-03-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "12149",
      "OFFICE": "Ts",
      "START": "1575-12-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "12156",
      "OFFICE": "Fs",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "12156",
      "OFFICE": "H1",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "12156",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "12156",
      "OFFICE": "Pt",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "12194",
      "OFFICE": "H2",
      "START": "1574-11-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "12205",
      "OFFICE": "GR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "12205",
      "OFFICE": "OHM",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "12206",
      "OFFICE": "Ts",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "12207",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "12207",
      "OFFICE": "K0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "12208",
      "OFFICE": "K",
      "START": "1576-07-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "12220",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "12220",
      "OFFICE": "OSilKX",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "12220",
      "OFFICE": "USilK",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "12222",
      "OFFICE": "OK",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "12307",
      "OFFICE": "Ms",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "12308",
      "OFFICE": "Ts",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "12309",
      "OFFICE": "Fs",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "12309",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "12313",
      "OFFICE": "GR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "12313",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "12313",
      "OFFICE": "K0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "12313",
      "OFFICE": "OStallM",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "12313",
      "OFFICE": "R",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "12323",
      "OFFICE": "K0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "12368",
      "OFFICE": "H2",
      "START": "1575-04-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "12368",
      "OFFICE": "Ts",
      "START": "1576-04-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "12374",
      "OFFICE": "H1",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "12374",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "12374",
      "OFFICE": "Ts",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "12390",
      "OFFICE": "Ms",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "12450",
      "OFFICE": "H2",
      "START": "1566-12-23",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "12532",
      "OFFICE": "H0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "12532",
      "OFFICE": "H1",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "12575",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "12615",
      "OFFICE": "H0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "12650",
      "OFFICE": "HKrR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "12661",
      "OFFICE": "Fs",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "12661",
      "OFFICE": "H0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "12690",
      "OFFICE": "HCSekHU",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "12690",
      "OFFICE": "R",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "12776",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "12776",
      "OFFICE": "Ts",
      "START": "1575-09-22",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "12778",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "12778",
      "OFFICE": "Ts",
      "START": "1575-05-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "12864",
      "OFFICE": "GR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "12864",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "12864",
      "OFFICE": "K0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "12864",
      "OFFICE": "OHM",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "12864",
      "OFFICE": "OK",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "12865",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "12865",
      "OFFICE": "K0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "12876",
      "OFFICE": "HKrR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "12876",
      "OFFICE": "OHMar",
      "START": "1573-03-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "12910",
      "OFFICE": "Ms",
      "START": "1566-12-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "12910",
      "OFFICE": "Ts",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "12929",
      "OFFICE": "Ts",
      "START": "1576-05-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "12934",
      "OFFICE": "Ts",
      "START": "1574-07-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "12957",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "12957",
      "OFFICE": "Ms",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "12957",
      "OFFICE": "Ts",
      "START": "1566-01-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "13015",
      "OFFICE": "Fs",
      "START": "1575-01-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "13015",
      "OFFICE": "H2",
      "START": "1566-12-14",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "13015",
      "OFFICE": "Ts",
      "START": "1573-11-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "13018",
      "OFFICE": "H2",
      "START": "1575-03-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "13051",
      "OFFICE": "HKrR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "13051",
      "OFFICE": "RHR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "13052",
      "OFFICE": "GR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "13052",
      "OFFICE": "HKrR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "13099",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "13099",
      "OFFICE": "Ts",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "13129",
      "OFFICE": "Ts",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "13211",
      "OFFICE": "H0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "13211",
      "OFFICE": "Ts",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "13259",
      "OFFICE": "HKaP",
      "START": "1575-11-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "13259",
      "OFFICE": "HKaR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "13263",
      "OFFICE": "RHR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "13297",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "13299",
      "OFFICE": "RHR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "13310",
      "OFFICE": "H1",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "13310",
      "OFFICE": "K",
      "START": "1575-09-18",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "13310",
      "OFFICE": "Ms",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "13310",
      "OFFICE": "Ts",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "13364",
      "OFFICE": "H0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "13395",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "13404",
      "OFFICE": "H0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "13404",
      "OFFICE": "Ms",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "13421",
      "OFFICE": "OTs",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "13444",
      "OFFICE": "OK\u00fcM",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "13444",
      "OFFICE": "Pt",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "13488",
      "OFFICE": "Fs",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "13488",
      "OFFICE": "H1",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "13488",
      "OFFICE": "Ms",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "13488",
      "OFFICE": "TraHM",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "13528",
      "OFFICE": "Ms",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "13597",
      "OFFICE": "H",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "13663",
      "OFFICE": "RHSek",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "13676",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "13676",
      "OFFICE": "K0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "13676",
      "OFFICE": "OHMar",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "13706",
      "OFFICE": "RHR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "13726",
      "OFFICE": "Pt",
      "START": "1573-09-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "13726",
      "OFFICE": "Ts",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "13768",
      "OFFICE": "H3",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "13768",
      "OFFICE": "Ms",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "13772",
      "OFFICE": "H3",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "13773",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "13773",
      "OFFICE": "H3",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "13774",
      "OFFICE": "H3",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "13775",
      "OFFICE": "H3",
      "START": "1573-01-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "13778",
      "OFFICE": "H2",
      "START": "1573-11-09",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "13779",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "13780",
      "OFFICE": "H1",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "13780",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "13853",
      "OFFICE": "Ms",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "13853",
      "OFFICE": "TraHM",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "14025",
      "OFFICE": "GR",
      "START": "1573-12-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "14027",
      "OFFICE": "GR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "14027",
      "OFFICE": "HVC",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "14028",
      "OFFICE": "RHR",
      "START": "1578-08-08",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "14031",
      "OFFICE": "HKaR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "14066",
      "OFFICE": "H3",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "14160",
      "OFFICE": "RHP",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "14165",
      "OFFICE": "RHR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "14172",
      "OFFICE": "HKaR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "14183",
      "OFFICE": "HCSekBG",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "14207",
      "OFFICE": "H0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "14209",
      "OFFICE": "E",
      "START": "",
      "END": "1576"
  },
  {
      "COURT": "M2",
      "ID": "14209",
      "OFFICE": "H1",
      "START": "1576-09-20",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "14386",
      "OFFICE": "H3",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "14430",
      "OFFICE": "HKaR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "14430",
      "OFFICE": "RHR",
      "START": "1566-02-14",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "14438",
      "OFFICE": "OHMar",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "14451",
      "OFFICE": "Ms",
      "START": "1573-01-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "14458",
      "OFFICE": "Fs",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "14458",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "14458",
      "OFFICE": "Pt",
      "START": "1566-12-15",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "14458",
      "OFFICE": "Ts",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "14461",
      "OFFICE": "HKrQM",
      "START": "1573-07-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "14462",
      "OFFICE": "OFalkM",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "14463",
      "OFFICE": "H2",
      "START": "1572-08-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "14464",
      "OFFICE": "H2",
      "START": "1574-01-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "14465",
      "OFFICE": "H1",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "14465",
      "OFFICE": "H2",
      "START": "1573-10-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "14469",
      "OFFICE": "H1",
      "START": "1575-06-28",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "14469",
      "OFFICE": "H2",
      "START": "1575-09-22",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "14470",
      "OFFICE": "H2",
      "START": "1572-08-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "14511",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "14511",
      "OFFICE": "Ts",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "14547",
      "OFFICE": "Ts",
      "START": "1573-01-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "14558",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "14558",
      "OFFICE": "Ts",
      "START": "1575-09-05",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "14601",
      "OFFICE": "H1",
      "START": "1575-06-28",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "14641",
      "OFFICE": "H1",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "14642",
      "OFFICE": "Fs",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "14642",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "14642",
      "OFFICE": "Ts",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "14646",
      "OFFICE": "H2",
      "START": "1574-07-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "14646",
      "OFFICE": "Ts",
      "START": "1575-09-22",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "14657",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "14657",
      "OFFICE": "HarHM",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "14657",
      "OFFICE": "Pt",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "14657",
      "OFFICE": "Ts",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "14684",
      "OFFICE": "H1",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "14684",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "14747",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "14747",
      "OFFICE": "Ts",
      "START": "1575-07-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "14747",
      "OFFICE": "USilK",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "14768",
      "OFFICE": "H2",
      "START": "1565-11-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "14768",
      "OFFICE": "H3",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "14777",
      "OFFICE": "H1",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "14783",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "14794",
      "OFFICE": "H3",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "14794",
      "OFFICE": "HarHM",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "14812",
      "OFFICE": "H3",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "14832",
      "OFFICE": "HKaSek",
      "START": "1575-06-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "14834",
      "OFFICE": "H1",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "14842",
      "OFFICE": "Ms",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "14842",
      "OFFICE": "Ts",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "14878",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "14896",
      "OFFICE": "H1",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "14896",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "14956",
      "OFFICE": "H1",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "14956",
      "OFFICE": "Pt",
      "START": "1575-08-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "14956",
      "OFFICE": "Ts",
      "START": "1572-06-16",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "14961",
      "OFFICE": "OHM",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "14961",
      "OFFICE": "R",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "14965",
      "OFFICE": "Fs",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "14965",
      "OFFICE": "H0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "14965",
      "OFFICE": "Ms",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "14965",
      "OFFICE": "Pt",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "14975",
      "OFFICE": "H1",
      "START": "1576-01-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "14980",
      "OFFICE": "Fs",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "14980",
      "OFFICE": "Ts",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "14988",
      "OFFICE": "H3",
      "START": "1573-10-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "15032",
      "OFFICE": "OStallM",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "15068",
      "OFFICE": "HCSekES",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "15069",
      "OFFICE": "HCSekES",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "15089",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "15093",
      "OFFICE": "Ms",
      "START": "1573-01-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "15094",
      "OFFICE": "H3",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "15196",
      "OFFICE": "HCSekHU",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "15381",
      "OFFICE": "H3",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "15474",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "15599",
      "OFFICE": "H1",
      "START": "1576-05-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "15615",
      "OFFICE": "H3",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "15688",
      "OFFICE": "H3",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "15697",
      "OFFICE": "H0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "15703",
      "OFFICE": "H0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "15703",
      "OFFICE": "H1",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "15718",
      "OFFICE": "H3",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "15736",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "15736",
      "OFFICE": "H3",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "15761",
      "OFFICE": "Ts",
      "START": "1575-01-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "15763",
      "OFFICE": "RHR",
      "START": "1575-01-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "15776",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "15776",
      "OFFICE": "Ts",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "15785",
      "OFFICE": "H0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "15791",
      "OFFICE": "H0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "15870",
      "OFFICE": "HCSekHU",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "16074",
      "OFFICE": "Ts",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "16099",
      "OFFICE": "H",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "16099",
      "OFFICE": "H0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "16194",
      "OFFICE": "Ms",
      "START": "1573-10-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "16357",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "16475",
      "OFFICE": "H1",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "16497",
      "OFFICE": "Hs",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "16498",
      "OFFICE": "H0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "16498",
      "OFFICE": "H1",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "16498",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "16498",
      "OFFICE": "Ts",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "16699",
      "OFFICE": "H0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "16699",
      "OFFICE": "H3",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "16699",
      "OFFICE": "Ms",
      "START": "1566-04-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "16801",
      "OFFICE": "H3",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "16945",
      "OFFICE": "H0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "16945",
      "OFFICE": "Ms",
      "START": "1566-05-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "16952",
      "OFFICE": "H1",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17010",
      "OFFICE": "H1",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17012",
      "OFFICE": "RHR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17051",
      "OFFICE": "H1",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17051",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17051",
      "OFFICE": "USilK",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17102",
      "OFFICE": "H0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17102",
      "OFFICE": "H3",
      "START": "1565-12-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17116",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17116",
      "OFFICE": "Ts",
      "START": "1566-12-15",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17118",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17118",
      "OFFICE": "Ts",
      "START": "1566-12-15",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17119",
      "OFFICE": "RHR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17127",
      "OFFICE": "H0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17127",
      "OFFICE": "H2",
      "START": "1566-12-14",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17140",
      "OFFICE": "H1",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17140",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17140",
      "OFFICE": "Ts",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17145",
      "OFFICE": "H0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17145",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17150",
      "OFFICE": "H1",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17156",
      "OFFICE": "H1",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17232",
      "OFFICE": "H0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17244",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17245",
      "OFFICE": "H0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17245",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17245",
      "OFFICE": "Ts",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17263",
      "OFFICE": "H1",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17272",
      "OFFICE": "H0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17272",
      "OFFICE": "Ts",
      "START": "1566-04-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17273",
      "OFFICE": "H0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17277",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17290",
      "OFFICE": "HCSek",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17290",
      "OFFICE": "HCSekBO",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17290",
      "OFFICE": "RHSek",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17291",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17291",
      "OFFICE": "Pt",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17291",
      "OFFICE": "Ts",
      "START": "1566-12-15",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17292",
      "OFFICE": "Ts",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17312",
      "OFFICE": "H0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17313",
      "OFFICE": "H0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17313",
      "OFFICE": "H1",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17334",
      "OFFICE": "Ts",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17357",
      "OFFICE": "HKaSek",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17361",
      "OFFICE": "GR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17367",
      "OFFICE": "HKaR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17375",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17404",
      "OFFICE": "H2",
      "START": "1566-12-14",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17404",
      "OFFICE": "Ts",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17409",
      "OFFICE": "Fs",
      "START": "1566-12-15",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17409",
      "OFFICE": "H1",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17409",
      "OFFICE": "Pt",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17409",
      "OFFICE": "Ts",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17410",
      "OFFICE": "H3",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17427",
      "OFFICE": "H1",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17461",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17488",
      "OFFICE": "H1",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17513",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17549",
      "OFFICE": "H0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17549",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17557",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17557",
      "OFFICE": "Pt",
      "START": "1576-05-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17557",
      "OFFICE": "Ts",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17557",
      "OFFICE": "USilK",
      "START": "1566-12-24",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17558",
      "OFFICE": "H1",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17558",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17558",
      "OFFICE": "HKrQM",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17560",
      "OFFICE": "H2",
      "START": "1566-02-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17569",
      "OFFICE": "HKaR",
      "START": "1573-01-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17569",
      "OFFICE": "RHR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17569",
      "OFFICE": "Ts",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17574",
      "OFFICE": "H1",
      "START": "1566-01-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17574",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17585",
      "OFFICE": "H0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17585",
      "OFFICE": "H1",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17585",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17587",
      "OFFICE": "Ts",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17606",
      "OFFICE": "Med",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17607",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17608",
      "OFFICE": "H0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17608",
      "OFFICE": "Ms",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17613",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17613",
      "OFFICE": "Ts",
      "START": "1566-12-15",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17617",
      "OFFICE": "Ts",
      "START": "1575-04-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17643",
      "OFFICE": "RHR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17646",
      "OFFICE": "RHR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17671",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17671",
      "OFFICE": "OFalkM",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17673",
      "OFFICE": "Fs",
      "START": "1575-07-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17673",
      "OFFICE": "H1",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17673",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17673",
      "OFFICE": "Pt",
      "START": "1574-11-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17715",
      "OFFICE": "H0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17715",
      "OFFICE": "H3",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17715",
      "OFFICE": "Ms",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17734",
      "OFFICE": "Kd",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17782",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17790",
      "OFFICE": "H",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17790",
      "OFFICE": "H0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17796",
      "OFFICE": "OFalkM",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17803",
      "OFFICE": "Pt",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17803",
      "OFFICE": "Ts",
      "START": "1566-12-15",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17803",
      "OFFICE": "USilK",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17804",
      "OFFICE": "H",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17804",
      "OFFICE": "H0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17811",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17815",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17816",
      "OFFICE": "H1",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17816",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17816",
      "OFFICE": "Ts",
      "START": "1566-03-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17840",
      "OFFICE": "Med",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17842",
      "OFFICE": "Med",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17845",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17845",
      "OFFICE": "OSilK",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17847",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17847",
      "OFFICE": "OSilK",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17847",
      "OFFICE": "Pt",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17847",
      "OFFICE": "Ts",
      "START": "1566-12-15",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17848",
      "OFFICE": "H0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17848",
      "OFFICE": "Ms",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17848",
      "OFFICE": "Pt",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17851",
      "OFFICE": "GR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17851",
      "OFFICE": "HVC",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17866",
      "OFFICE": "H0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17866",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17871",
      "OFFICE": "H0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17896",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17934",
      "OFFICE": "Ts",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17943",
      "OFFICE": "H0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17943",
      "OFFICE": "Ms",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17943",
      "OFFICE": "Ts",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17954",
      "OFFICE": "Ts",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17973",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17981",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17982",
      "OFFICE": "H1",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "17983",
      "OFFICE": "Ts",
      "START": "1575-06-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "18366",
      "OFFICE": "H0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "18677",
      "OFFICE": "OK\u00fcM",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "18769",
      "OFFICE": "H3",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "18788",
      "OFFICE": "Ms",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "18793",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "18793",
      "OFFICE": "K0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "18820",
      "OFFICE": "H3",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "18904",
      "OFFICE": "Ts",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "18946",
      "OFFICE": "H0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "18946",
      "OFFICE": "Ms",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "18991",
      "OFFICE": "H1",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "18997",
      "OFFICE": "Ms",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "18997",
      "OFFICE": "Ts",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "19103",
      "OFFICE": "H0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "19103",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "19103",
      "OFFICE": "Pt",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "19103",
      "OFFICE": "Ts",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "19176",
      "OFFICE": "H1",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "19193",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "19283",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "19283",
      "OFFICE": "Ts",
      "START": "1566-12-15",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "19341",
      "OFFICE": "H0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "19341",
      "OFFICE": "H1",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "19354",
      "OFFICE": "H3",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "19354",
      "OFFICE": "RHR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "19365",
      "OFFICE": "Ts",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "19370",
      "OFFICE": "H1",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "19370",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "19373",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "19431",
      "OFFICE": "Ts",
      "START": "1573-01-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "19443",
      "OFFICE": "Fs",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "19443",
      "OFFICE": "HarHM",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "19460",
      "OFFICE": "H1",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "19460",
      "OFFICE": "H2",
      "START": "1572-05-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "19468",
      "OFFICE": "H3",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "19479",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "19496",
      "OFFICE": "Ts",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "19499",
      "OFFICE": "Ms",
      "START": "1575-12-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "19521",
      "OFFICE": "H1",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "19521",
      "OFFICE": "H2",
      "START": "1566-01-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "19527",
      "OFFICE": "H2",
      "START": "1575-01-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "19599",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "19599",
      "OFFICE": "H3",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "19655",
      "OFFICE": "H1",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "19655",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "19656",
      "OFFICE": "H1",
      "START": "1576-04-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "19773",
      "OFFICE": "Ms",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "19773",
      "OFFICE": "Pt",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "19773",
      "OFFICE": "Ts",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "19865",
      "OFFICE": "Ts",
      "START": "1572-07-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "19871",
      "OFFICE": "H2",
      "START": "1574-06-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "31087",
      "OFFICE": "H2",
      "START": "1576-03-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "31088",
      "OFFICE": "Med",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "31089",
      "OFFICE": "H1",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "31089",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "31089",
      "OFFICE": "RHR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "31090",
      "OFFICE": "RHSek",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "31097",
      "OFFICE": "HCSek",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "31105",
      "OFFICE": "HKaR",
      "START": "1574-07-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "31110",
      "OFFICE": "HKaSek",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "31113",
      "OFFICE": "HKaD",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "31115",
      "OFFICE": "HKaR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "31123",
      "OFFICE": "HKaSek",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "31128",
      "OFFICE": "HKrSek",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "31129",
      "OFFICE": "HKrSek",
      "START": "1575-02-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "31148",
      "OFFICE": "HKaSek",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "31149",
      "OFFICE": "HZKt",
      "START": "1572-03-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "31156",
      "OFFICE": "HKaSek",
      "START": "1573-01-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "31157",
      "OFFICE": "HB",
      "START": "1574-03-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "31157",
      "OFFICE": "HKaD",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "31169",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "31173",
      "OFFICE": "Fs",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "31173",
      "OFFICE": "Ms",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "31173",
      "OFFICE": "OSilK",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "31174",
      "OFFICE": "H2",
      "START": "1573-01-01",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "31181",
      "OFFICE": "H1",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "31181",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "31210",
      "OFFICE": "HPfenM",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "31210",
      "OFFICE": "R",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "31222",
      "OFFICE": "HKt",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "31488",
      "OFFICE": "HKrR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "31489",
      "OFFICE": "HKrR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "31492",
      "OFFICE": "HPostM",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "31496",
      "OFFICE": "HPostMX",
      "START": "",
      "END": ""
  },
  {
      "COURT": "M2",
      "ID": "31692",
      "OFFICE": "HKaD",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "10003",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "10003",
      "OFFICE": "RHR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "10015",
      "OFFICE": "K0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "10015",
      "OFFICE": "TraHM",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "10021",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "10024",
      "OFFICE": "GR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "10024",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "10024",
      "OFFICE": "OK",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "10030",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "10037",
      "OFFICE": "RHR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "10044",
      "OFFICE": "RHR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "10052",
      "OFFICE": "OStallM",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "10053",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "10053",
      "OFFICE": "K0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "10075",
      "OFFICE": "GR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "10099",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "10099",
      "OFFICE": "OStallM",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "10105",
      "OFFICE": "HKrR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "10113",
      "OFFICE": "GR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "10113",
      "OFFICE": "K0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "10117",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "10123",
      "OFFICE": "HCSekCZ",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "10123",
      "OFFICE": "R",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "10126",
      "OFFICE": "HKaR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "10127",
      "OFFICE": "RHR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "10132",
      "OFFICE": "R",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "10137",
      "OFFICE": "GR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "10137",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "10137",
      "OFFICE": "OHMar",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "10138",
      "OFFICE": "HKaR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "10150",
      "OFFICE": "GR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "10188",
      "OFFICE": "H",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "10215",
      "OFFICE": "Ts",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "10228",
      "OFFICE": "GR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "10228",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "10228",
      "OFFICE": "OHM",
      "START": "1615",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "10301",
      "OFFICE": "Pt",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "10355",
      "OFFICE": "Pt",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "10355",
      "OFFICE": "Ts",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "10370",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "10370",
      "OFFICE": "K0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "10385",
      "OFFICE": "HKaR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "10385",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "10389",
      "OFFICE": "HarHM",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "10389",
      "OFFICE": "HKrR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "10389",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "10448",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "10454",
      "OFFICE": "Ms",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "10476",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "10530",
      "OFFICE": "RHP",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "10582",
      "OFFICE": "HKrSek",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "10636",
      "OFFICE": "Ms",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "10667",
      "OFFICE": "Pt",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "10728",
      "OFFICE": "HKrR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "10728",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "10728",
      "OFFICE": "K0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "10793",
      "OFFICE": "GR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "10793",
      "OFFICE": "HVC",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "11080",
      "OFFICE": "OK",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "11098",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "11108",
      "OFFICE": "RHR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "11152",
      "OFFICE": "K0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "11290",
      "OFFICE": "K0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "11323",
      "OFFICE": "HB",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "11337",
      "OFFICE": "Ms",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "11346",
      "OFFICE": "RHR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "11362",
      "OFFICE": "Ts",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "11502",
      "OFFICE": "HZM",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "11504",
      "OFFICE": "Ms",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "11518",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "11577",
      "OFFICE": "K0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "11618",
      "OFFICE": "GR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "11657",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "11708",
      "OFFICE": "Ts",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "11728",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "11728",
      "OFFICE": "K0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "11854",
      "OFFICE": "Fs",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "11990",
      "OFFICE": "Math",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "12161",
      "OFFICE": "K0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "12190",
      "OFFICE": "K0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "12208",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "12209",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "12344",
      "OFFICE": "K0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "12406",
      "OFFICE": "GR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "12534",
      "OFFICE": "K0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "12656",
      "OFFICE": "Pt",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "12656",
      "OFFICE": "Ts",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "12762",
      "OFFICE": "Pt",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "13121",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "13124",
      "OFFICE": "GR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "13124",
      "OFFICE": "HKrP",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "13124",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "13358",
      "OFFICE": "Fs",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "13366",
      "OFFICE": "Ms",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "13396",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "13695",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "13695",
      "OFFICE": "OHMar",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "13695",
      "OFFICE": "R",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "13720",
      "OFFICE": "Ts",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "13812",
      "OFFICE": "OTs",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "14008",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "14029",
      "OFFICE": "HKaR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "14037",
      "OFFICE": "RHF",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "14080",
      "OFFICE": "R",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "14122",
      "OFFICE": "HKaSek",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "14174",
      "OFFICE": "H",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "14308",
      "OFFICE": "K0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "14379",
      "OFFICE": "K0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "14379",
      "OFFICE": "OTs",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "14390",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "14392",
      "OFFICE": "RHR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "14506",
      "OFFICE": "Ms",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "14546",
      "OFFICE": "Ms",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "14588",
      "OFFICE": "R",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "14611",
      "OFFICE": "K0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "14667",
      "OFFICE": "Fs",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "14687",
      "OFFICE": "H",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "14688",
      "OFFICE": "Pt",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "14771",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "14772",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "14772",
      "OFFICE": "TraHM",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "14849",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "14885",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "14885",
      "OFFICE": "K0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "14940",
      "OFFICE": "Ms",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "14959",
      "OFFICE": "H",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "15679",
      "OFFICE": "H",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "15767",
      "OFFICE": "Fs",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "17054",
      "OFFICE": "Kd",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "17069",
      "OFFICE": "Ms",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "17070",
      "OFFICE": "Ms",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "17077",
      "OFFICE": "Ms",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "17078",
      "OFFICE": "Pt",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "17078",
      "OFFICE": "USilK",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "17082",
      "OFFICE": "H",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "17088",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "17098",
      "OFFICE": "K0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "17169",
      "OFFICE": "Fs",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "17180",
      "OFFICE": "Pt",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "17196",
      "OFFICE": "Ts",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "17198",
      "OFFICE": "Ts",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "17220",
      "OFFICE": "HPostM",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "17279",
      "OFFICE": "HKrR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "17281",
      "OFFICE": "So",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "17335",
      "OFFICE": "OFalkM",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "17369",
      "OFFICE": "Ts",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "17417",
      "OFFICE": "RHR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "17432",
      "OFFICE": "H",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "17436",
      "OFFICE": "HKaR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "17449",
      "OFFICE": "Fs",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "17449",
      "OFFICE": "Ts",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "17469",
      "OFFICE": "H",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "17479",
      "OFFICE": "Ts",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "17484",
      "OFFICE": "H",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "17491",
      "OFFICE": "Hs",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "17554",
      "OFFICE": "HCSekBO",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "17570",
      "OFFICE": "RHR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "17598",
      "OFFICE": "Ms",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "17717",
      "OFFICE": "Ts",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "17729",
      "OFFICE": "RHR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "17732",
      "OFFICE": "H",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "17737",
      "OFFICE": "Kd",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "17873",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "17899",
      "OFFICE": "H",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "17931",
      "OFFICE": "H",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "17941",
      "OFFICE": "K0",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "17977",
      "OFFICE": "Fs",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "19038",
      "OFFICE": "R",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "19106",
      "OFFICE": "Ms",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "19129",
      "OFFICE": "RHR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "19170",
      "OFFICE": "GR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "19245",
      "OFFICE": "R",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "19345",
      "OFFICE": "Ts",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "19639",
      "OFFICE": "HKrSek",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "19875",
      "OFFICE": "Ts",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "31060",
      "OFFICE": "RHR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "31080",
      "OFFICE": "HKaSek",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "31147",
      "OFFICE": "H",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "31168",
      "OFFICE": "H",
      "START": "",
      "END": ""
  },
  {
      "COURT": "MS",
      "ID": "31224",
      "OFFICE": "H",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "10035",
      "OFFICE": "OSilK",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "10041",
      "OFFICE": "E",
      "START": "",
      "END": "1588"
  },
  {
      "COURT": "R2",
      "ID": "10087",
      "OFFICE": "GR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "10088",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "10098",
      "OFFICE": "OStallM",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "10099",
      "OFFICE": "R",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "10106",
      "OFFICE": "E",
      "START": "",
      "END": "1604"
  },
  {
      "COURT": "R2",
      "ID": "10150",
      "OFFICE": "RHR",
      "START": "1576-12-01",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "10252",
      "OFFICE": "E",
      "START": "",
      "END": "1599"
  },
  {
      "COURT": "R2",
      "ID": "10253",
      "OFFICE": "E",
      "START": "",
      "END": "1594"
  },
  {
      "COURT": "R2",
      "ID": "10264",
      "OFFICE": "OHM",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "10299",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "10423",
      "OFFICE": "E",
      "START": "",
      "END": "1576"
  },
  {
      "COURT": "R2",
      "ID": "10445",
      "OFFICE": "RHR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "10459",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "10482",
      "OFFICE": "E",
      "START": "",
      "END": "1592"
  },
  {
      "COURT": "R2",
      "ID": "10498",
      "OFFICE": "E",
      "START": "",
      "END": "1590"
  },
  {
      "COURT": "R2",
      "ID": "10554",
      "OFFICE": "E",
      "START": "",
      "END": "1612"
  },
  {
      "COURT": "R2",
      "ID": "10559",
      "OFFICE": "E",
      "START": "",
      "END": "1595"
  },
  {
      "COURT": "R2",
      "ID": "10577",
      "OFFICE": "Fs",
      "START": "1579-02-01",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "10644",
      "OFFICE": "E",
      "START": "",
      "END": "1597"
  },
  {
      "COURT": "R2",
      "ID": "10696",
      "OFFICE": "HKrR",
      "START": "1576-05-21",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "10760",
      "OFFICE": "E",
      "START": "",
      "END": "1581"
  },
  {
      "COURT": "R2",
      "ID": "10810",
      "OFFICE": "Ms",
      "START": "1576-12-01",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "10875",
      "OFFICE": "HKrR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "10876",
      "OFFICE": "RHR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "11016",
      "OFFICE": "RHR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "11080",
      "OFFICE": "R",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "11086",
      "OFFICE": "Ts",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "11107",
      "OFFICE": "RHR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "11150",
      "OFFICE": "RHR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "11203",
      "OFFICE": "RHR",
      "START": "1576-12-02",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "11214",
      "OFFICE": "E",
      "START": "",
      "END": "1577"
  },
  {
      "COURT": "R2",
      "ID": "11266",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "11275",
      "OFFICE": "Fs",
      "START": "1577-11-10",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "11276",
      "OFFICE": "E",
      "START": "",
      "END": "1604"
  },
  {
      "COURT": "R2",
      "ID": "11298",
      "OFFICE": "HKrR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "11352",
      "OFFICE": "OTs",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "11352",
      "OFFICE": "RHR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "11356",
      "OFFICE": "RHSek",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "11360",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "11411",
      "OFFICE": "RHR",
      "START": "1579-02-01",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "11428",
      "OFFICE": "Fs",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "11534",
      "OFFICE": "Ts",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "11546",
      "OFFICE": "HCSekLA",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "11547",
      "OFFICE": "HKaSek",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "11564",
      "OFFICE": "Ts",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "11573",
      "OFFICE": "E",
      "START": "",
      "END": "1592"
  },
  {
      "COURT": "R2",
      "ID": "11597",
      "OFFICE": "Fs",
      "START": "1579-02-08",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "11597",
      "OFFICE": "Ts",
      "START": "1576",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "11614",
      "OFFICE": "HZM",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "11642",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "11643",
      "OFFICE": "Med",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "11644",
      "OFFICE": "RHR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "11648",
      "OFFICE": "RHR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "11652",
      "OFFICE": "RHR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "11656",
      "OFFICE": "RHR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "11662",
      "OFFICE": "E",
      "START": "",
      "END": "1608"
  },
  {
      "COURT": "R2",
      "ID": "11667",
      "OFFICE": "E",
      "START": "",
      "END": "1596"
  },
  {
      "COURT": "R2",
      "ID": "11679",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "11693",
      "OFFICE": "E",
      "START": "",
      "END": "1597"
  },
  {
      "COURT": "R2",
      "ID": "11696",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "11699",
      "OFFICE": "Ts",
      "START": "1576",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "11701",
      "OFFICE": "RHR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "11711",
      "OFFICE": "HKaR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "11723",
      "OFFICE": "Ts",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "11726",
      "OFFICE": "Ts",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "11727",
      "OFFICE": "Ts",
      "START": "1576",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "11740",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "11759",
      "OFFICE": "So",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "11819",
      "OFFICE": "HKrR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "11847",
      "OFFICE": "Fs",
      "START": "1576-12-01",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "11854",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "11868",
      "OFFICE": "Fs",
      "START": "1579-07-15",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "11868",
      "OFFICE": "Ts",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "11893",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "11993",
      "OFFICE": "HKaD",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "11997",
      "OFFICE": "Med",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "12028",
      "OFFICE": "HKrR",
      "START": "1577-03-02",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "12082",
      "OFFICE": "OJM",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "12096",
      "OFFICE": "RHR",
      "START": "1577-11-13",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "12149",
      "OFFICE": "Fs",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "12149",
      "OFFICE": "Ts",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "12194",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "12205",
      "OFFICE": "GR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "12208",
      "OFFICE": "R",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "12243",
      "OFFICE": "E",
      "START": "",
      "END": "1589"
  },
  {
      "COURT": "R2",
      "ID": "12287",
      "OFFICE": "E",
      "START": "",
      "END": "1588"
  },
  {
      "COURT": "R2",
      "ID": "12296",
      "OFFICE": "E",
      "START": "",
      "END": "1592"
  },
  {
      "COURT": "R2",
      "ID": "12313",
      "OFFICE": "GR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "12368",
      "OFFICE": "Ts",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "12381",
      "OFFICE": "Ts",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "12388",
      "OFFICE": "Ts",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "12504",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "12506",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "12575",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "12575",
      "OFFICE": "OK",
      "START": "1576-12-01",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "12580",
      "OFFICE": "Ms",
      "START": "1576-12-01",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "12585",
      "OFFICE": "E",
      "START": "",
      "END": "1588"
  },
  {
      "COURT": "R2",
      "ID": "12650",
      "OFFICE": "HKrR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "12776",
      "OFFICE": "Ts",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "12816",
      "OFFICE": "OHMar",
      "START": "1576",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "12816",
      "OFFICE": "RHR",
      "START": "1576",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "12876",
      "OFFICE": "HKrR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "12876",
      "OFFICE": "OHMar",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "12909",
      "OFFICE": "E",
      "START": "",
      "END": "1588"
  },
  {
      "COURT": "R2",
      "ID": "12919",
      "OFFICE": "E",
      "START": "",
      "END": "1576"
  },
  {
      "COURT": "R2",
      "ID": "12929",
      "OFFICE": "Fs",
      "START": "1577-01-01",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "12929",
      "OFFICE": "Ts",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "12934",
      "OFFICE": "Ts",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "12951",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "13013",
      "OFFICE": "HKrR",
      "START": "1576-01-28",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "13029",
      "OFFICE": "E",
      "START": "",
      "END": "1612"
  },
  {
      "COURT": "R2",
      "ID": "13051",
      "OFFICE": "RHR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "13052",
      "OFFICE": "GR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "13052",
      "OFFICE": "HKrR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "13062",
      "OFFICE": "E",
      "START": "",
      "END": "1601"
  },
  {
      "COURT": "R2",
      "ID": "13066",
      "OFFICE": "Ms",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "13129",
      "OFFICE": "RHR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "13259",
      "OFFICE": "HKaP",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "13263",
      "OFFICE": "RHR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "13299",
      "OFFICE": "RHR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "13304",
      "OFFICE": "E",
      "START": "",
      "END": "1584"
  },
  {
      "COURT": "R2",
      "ID": "13305",
      "OFFICE": "Ms",
      "START": "1576-12-01",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "13351",
      "OFFICE": "HKaR",
      "START": "1576-12-01",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "13365",
      "OFFICE": "E",
      "START": "",
      "END": "1593"
  },
  {
      "COURT": "R2",
      "ID": "13391",
      "OFFICE": "E",
      "START": "",
      "END": "1592"
  },
  {
      "COURT": "R2",
      "ID": "13428",
      "OFFICE": "E",
      "START": "",
      "END": "1596"
  },
  {
      "COURT": "R2",
      "ID": "13444",
      "OFFICE": "OK\u00fcM",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "13468",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "13488",
      "OFFICE": "TraHM",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "13514",
      "OFFICE": "E",
      "START": "",
      "END": "1602"
  },
  {
      "COURT": "R2",
      "ID": "13558",
      "OFFICE": "E",
      "START": "",
      "END": "1604"
  },
  {
      "COURT": "R2",
      "ID": "13559",
      "OFFICE": "E",
      "START": "",
      "END": "1612"
  },
  {
      "COURT": "R2",
      "ID": "13636",
      "OFFICE": "Ms",
      "START": "1579-02-23",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "13663",
      "OFFICE": "RHSek",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "13689",
      "OFFICE": "Ms",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "13691",
      "OFFICE": "Ts",
      "START": "1576",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "13695",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "13695",
      "OFFICE": "R",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "13706",
      "OFFICE": "RHR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "13726",
      "OFFICE": "Pt",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "13730",
      "OFFICE": "E",
      "START": "",
      "END": "1576"
  },
  {
      "COURT": "R2",
      "ID": "13768",
      "OFFICE": "Ms",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "13771",
      "OFFICE": "Hs",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "13772",
      "OFFICE": "H3",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "13773",
      "OFFICE": "H3",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "13774",
      "OFFICE": "H3",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "13775",
      "OFFICE": "H3",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "13776",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "13776",
      "OFFICE": "H3",
      "START": "1576-12-01",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "13778",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "13779",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "13780",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "13811",
      "OFFICE": "Ms",
      "START": "1576-12-01",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "13812",
      "OFFICE": "Pt",
      "START": "1576",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "13817",
      "OFFICE": "Ms",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "13829",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "13908",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "14025",
      "OFFICE": "GR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "14025",
      "OFFICE": "RHR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "14027",
      "OFFICE": "GR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "14137",
      "OFFICE": "Fs",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "14137",
      "OFFICE": "Ms",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "14160",
      "OFFICE": "RHP",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "14165",
      "OFFICE": "RHR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "14209",
      "OFFICE": "H1",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "14374",
      "OFFICE": "K",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "14451",
      "OFFICE": "Ms",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "14461",
      "OFFICE": "HKrQM",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "14462",
      "OFFICE": "OFalkM",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "14463",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "14464",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "14465",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "14469",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "14470",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "14493",
      "OFFICE": "E",
      "START": "",
      "END": "1576"
  },
  {
      "COURT": "R2",
      "ID": "14494",
      "OFFICE": "Ms",
      "START": "1576-12-01",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "14512",
      "OFFICE": "Fs",
      "START": "1576-12-01",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "14547",
      "OFFICE": "Pt",
      "START": "1577-03-12",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "14547",
      "OFFICE": "Ts",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "14558",
      "OFFICE": "Pt",
      "START": "1578-01-01",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "14558",
      "OFFICE": "Ts",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "14601",
      "OFFICE": "H1",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "14602",
      "OFFICE": "E",
      "START": "",
      "END": "1612"
  },
  {
      "COURT": "R2",
      "ID": "14646",
      "OFFICE": "Ts",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "14657",
      "OFFICE": "HarHM",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "14663",
      "OFFICE": "Ts",
      "START": "1576",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "14689",
      "OFFICE": "Ms",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "14747",
      "OFFICE": "Ts",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "14747",
      "OFFICE": "USilK",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "14771",
      "OFFICE": "R",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "14783",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "14832",
      "OFFICE": "HKaSek",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "14833",
      "OFFICE": "HKaSek",
      "START": "1576",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "14834",
      "OFFICE": "H1",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "14895",
      "OFFICE": "Ts",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "14956",
      "OFFICE": "Pt",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "14975",
      "OFFICE": "H1",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "14992",
      "OFFICE": "Ts",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "15016",
      "OFFICE": "Fs",
      "START": "1576-12-01",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "15599",
      "OFFICE": "H1",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "15671",
      "OFFICE": "E",
      "START": "",
      "END": "1581"
  },
  {
      "COURT": "R2",
      "ID": "15672",
      "OFFICE": "E",
      "START": "",
      "END": "1604"
  },
  {
      "COURT": "R2",
      "ID": "15689",
      "OFFICE": "E",
      "START": "",
      "END": "1585"
  },
  {
      "COURT": "R2",
      "ID": "15726",
      "OFFICE": "E",
      "START": "",
      "END": "1592"
  },
  {
      "COURT": "R2",
      "ID": "15794",
      "OFFICE": "E",
      "START": "",
      "END": "1576"
  },
  {
      "COURT": "R2",
      "ID": "16140",
      "OFFICE": "H1",
      "START": "1576-12-01",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "16199",
      "OFFICE": "Ts",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "16497",
      "OFFICE": "Hs",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "16949",
      "OFFICE": "E",
      "START": "",
      "END": "1577"
  },
  {
      "COURT": "R2",
      "ID": "17051",
      "OFFICE": "Fs",
      "START": "1577-03-25",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "17334",
      "OFFICE": "Fs",
      "START": "1577-01-01",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "17334",
      "OFFICE": "Ts",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "17473",
      "OFFICE": "E",
      "START": "",
      "END": "1590"
  },
  {
      "COURT": "R2",
      "ID": "17569",
      "OFFICE": "HKaR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "17586",
      "OFFICE": "E",
      "START": "",
      "END": "1584"
  },
  {
      "COURT": "R2",
      "ID": "17596",
      "OFFICE": "E",
      "START": "",
      "END": "1576"
  },
  {
      "COURT": "R2",
      "ID": "17673",
      "OFFICE": "Fs",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "17706",
      "OFFICE": "E",
      "START": "",
      "END": "1576"
  },
  {
      "COURT": "R2",
      "ID": "17706",
      "OFFICE": "Ms",
      "START": "1578-12-01",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "17809",
      "OFFICE": "E",
      "START": "",
      "END": "1592"
  },
  {
      "COURT": "R2",
      "ID": "17910",
      "OFFICE": "RHR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "18904",
      "OFFICE": "Pt",
      "START": "1577-01-01",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "18904",
      "OFFICE": "Ts",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "19027",
      "OFFICE": "Fs",
      "START": "1579-02-01",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "19416",
      "OFFICE": "Ms",
      "START": "1578-12-07",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "19499",
      "OFFICE": "Ms",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "19509",
      "OFFICE": "H2",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "19649",
      "OFFICE": "E",
      "START": "",
      "END": "1605"
  },
  {
      "COURT": "R2",
      "ID": "19656",
      "OFFICE": "H1",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "19865",
      "OFFICE": "Ts",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "31090",
      "OFFICE": "RHSek",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "31105",
      "OFFICE": "HKaR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "31110",
      "OFFICE": "HKaSek",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "31113",
      "OFFICE": "HKaD",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "31115",
      "OFFICE": "HKaR",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "31128",
      "OFFICE": "HKrSek",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "31129",
      "OFFICE": "HKrSek",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "31149",
      "OFFICE": "HZKt",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "31156",
      "OFFICE": "HKaSek",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "31180",
      "OFFICE": "RHR",
      "START": "1579-06-01",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "31222",
      "OFFICE": "HKt",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "31496",
      "OFFICE": "HPostMX",
      "START": "",
      "END": ""
  },
  {
      "COURT": "R2",
      "ID": "31692",
      "OFFICE": "HKaD",
      "START": "",
      "END": ""
  }
  ]
